/** @typedef {'en' | 'ar'} Locale */

export const STORAGE_KEY = 'holol-lang';


export const translations = {
  en: {
    meta: {
      title: 'holol Club | Your smart solutions, your successful consultations',
      description: 'holol Club — Your smart solutions, your successful consultations',
    },
    nav: {
      services: 'Services',
      idea: 'Our Idea',
      about: 'About Us',
      partners: 'Partners',
      contact: 'Contact',
      joinUs: 'Join Us',
      joinPartner: 'Join Us',
      founder: 'Founder',
      aiAssistant: 'holol AI',
      switchLang: 'العربية',
    },
    hero: {
      slogan: 'The first digital franchise worldwide',
      slogan2: 'Your smart solutions, your successful consultations',
      title1: 'holol Club for Consulting',
      title2: 'Legal, Accounting, Financing, Advertising & Marketing, Feasibility, Residency, and Immigration services',
      subtitle:
        'holol Club is the preferred destination for leading global companies, entrepreneurs, and startups, where we combine legal, financial, strategic, and investment expertise to accelerate your business growth at the heart of the global economy.',
      ctaPartner: 'Join Us',
      ctaProvider: 'Our Previous Work',
      ctaLatestProjects: 'Our Latest Projects',
      statPartners: 'Featured Partners',
      statOffices: 'Global Services',
      statSuccess: 'Success Guaranteed',
      statCapital: 'Rapid Growth',
      statBillion: 'Billion+',
      imgAlt:
        'Cinematic low angle shot of modern glass skyscrapers reaching into a deep blue night sky with golden office lights',
    },
    about: {
      kicker: 'Holol Club',
      title: 'Committed to Distinction.',
      p1: 'At holol Club, we believe sustainable success is never accidental. It is built through precise strategic planning and integrated support. We provide an exclusive platform that combines local expertise with global insight.',
      p2: 'We are the institutional backbone of your business, providing the tools and network needed to confidently navigate complex systems and regulations and manage your business across global markets.',
      p3: 'An integrated ecosystem combining professional expertise, media reach, and financial and marketing solutions across more than 50 countries, with launch hubs in Egypt, Saudi Arabia, and the UAE.',
      strategicTitle: 'Strategic',
      strategicDesc: 'Unlocking potential through tailor-made advisory services.',
      globalTitle: 'Global',
      globalDesc: 'Connecting you with elite service providers worldwide.',
      cardTitle: 'holol Standard',
      cardBody:
        'Every partner goes through a rigorous selection process to ensure the highest standards of integrity and professional competence across our ecosystem.',
      cardImgAlt:
        'Modern minimalist office interior with white marble walls and a single golden sculptural element',
      learnMoreText: 'To learn more about us',
      learnMoreCta: 'Learn more',
    },
    services: {
      kicker: 'holol Club',
      title: 'Share your expertise... Join the elite network of service providers',
    },
    serviceItems: [
      {
        title: 'Legal Advisory',
        subtitle: 'Legal',
        desc: 'Premium legal frameworks to protect contracts and corporate governance.',
      },
      {
        title: 'Accounting & Audit',
        subtitle: 'Accounting',
        desc: 'Accurate financial reporting and tax optimization strategies.',
      },
      {
        title: 'Financing Solutions',
        subtitle: 'Financing',
        desc: 'Access to capital markets and customized liquidity facilities.',
      },
      {
        title: 'Feasibility Studies',
        subtitle: 'Feasibility',
        desc: 'Data-driven market analysis and predictive project modeling.',
      },
      {
        title: 'Advertising and Marketing',
        subtitle: 'Marketing',
        desc: 'Launch your brand for a global audience.',
      },
      {
        title: 'Residence & Immigration',
        subtitle: 'Residency & Mobility',
        desc: 'Smooth global transitions through premium services.',
      },
    ],
    serviceIcons: ['gavel', 'account_balance_wallet', 'payments', 'analytics', 'campaign', 'travel_explore'],
    serviceSlugs: ['legal', 'accounting', 'financing', 'feasibility', 'marketing', 'immigration'],
    serviceDetails: [
      {
        title: 'Legal Advisory',
        subtitle: 'Legal',
        heroDesc: 'Comprehensive legal support for businesses and individuals navigating every stage of a project — from idea to expansion or wind-down.',
        details: [
          'Our legal advisory team provides end-to-end support for corporate legal matters, ensuring your business operates within the bounds of local and international law.',
          'We specialize in contract drafting and negotiation, mergers and acquisitions, corporate governance frameworks, and intellectual property protection.',
          'Whether you are launching a new venture, expanding across borders, or resolving disputes, our network of accredited legal experts delivers tailored solutions with precision and confidentiality.',
        ],
        categories: [
          {
            title: 'Corporate Formation & Governance',
            icon: 'corporate_fare',
            services: [
              { name: 'Company Formation', desc: 'Sole proprietorship, joint-stock, and LLC setup with optimal tax and legal entity selection.' },
              { name: 'Articles of Association', desc: 'Drafting founding contracts and amendments that secure all partners\' rights.' },
              { name: 'Board Secretarial Services', desc: 'Organizing board meetings and drafting official minutes.' },
              { name: 'Shareholders\' Agreements', desc: 'Protecting minority and majority rights with clear partner exit mechanisms.' },
              { name: 'Compliance & Governance', desc: 'Aligning company operations with local laws and regulatory frameworks.' },
            ],
          },
          {
            title: 'Real Estate & Construction',
            icon: 'real_estate_agent',
            services: [
              { name: 'Legal Due Diligence', desc: 'Verifying the legal soundness of property documents before purchase.' },
              { name: 'Property Registration & Transfer', desc: 'Real estate registration procedures and official documentation.' },
              { name: 'Construction Contracts', desc: 'Drafting and reviewing FIDIC contracts with contractors and suppliers.' },
              { name: 'Rental Dispute Management', desc: 'Drafting lease agreements and handling eviction or rent-collection cases.' },
              { name: 'Real Estate Investment Funds', desc: 'Legal structuring for real estate financing and development projects.' },
            ],
          },
          {
            title: 'Contracts & Commercial Operations',
            icon: 'handshake',
            services: [
              { name: 'Commercial Contract Drafting', desc: 'Supply, distribution, commercial agency, and brokerage agreements.' },
              { name: 'Franchise Rights', desc: 'Drafting franchise contracts and trademark protection for franchisors and franchisees.' },
              { name: 'Contract Review & Audit', desc: 'Assessing legal risks in contracts the client has previously signed.' },
              { name: 'NDA & Non-Compete Agreements', desc: 'Protecting business secrets during negotiations with partners or employees.' },
            ],
          },
          {
            title: 'Labor & Human Resources',
            icon: 'groups',
            services: [
              { name: 'Employment Contract Drafting', desc: 'Compliant with local labor law and protecting employers from loopholes.' },
              { name: 'Company Internal Regulations', desc: 'Penalty and reward policies approved by the Ministry of Labor.' },
              { name: 'Labor Case Representation', desc: 'Representing companies before labor courts and dispute settlement committees.' },
            ],
          },
          {
            title: 'Intellectual Property & Digital',
            icon: 'verified',
            services: [
              { name: 'Trademark Registration', desc: 'Protecting intellectual property, industrial models and designs.' },
              { name: 'E-Commerce Law', desc: 'Drafting Terms & Conditions and privacy policies for websites and applications.' },
            ],
          },
          {
            title: 'Litigation & Debt Collection',
            icon: 'gavel',
            services: [
              { name: 'Debt Collection', desc: 'Amicable and judicial collection: legal notices and enforcement procedures.' },
              { name: 'Judicial Representation', desc: 'Civil and commercial cases before all court levels.' },
              { name: 'Arbitration & Mediation', desc: 'Alternative dispute resolution for speed and confidentiality.' },
            ],
          },
          {
            title: 'Premium & Elite Services',
            icon: 'stars',
            services: [
              { name: 'Estate & Inheritance Planning', desc: 'Drafting wills and managing inter-generational wealth transfer (Family Office Support).' },
              { name: 'Residency & Citizenship Advisory', desc: 'Legal aspects of investor residency and citizenship-by-investment programs.' },
              { name: 'Comprehensive Legal Audit', desc: 'Periodic report revealing legal gaps in the client\'s current investments.' },
            ],
          },
        ],
        videoSrc: '/media/videos/service-legal.mp4',
        videoLabel: 'Legal Advisory Overview',
      },
      {
        title: 'Accounting & Audit',
        subtitle: 'Accounting',
        heroDesc: 'The language of numbers every investor needs — covering daily operations and long-term financial strategy.',
        details: [
          'holol Club connects you with certified accounting professionals who deliver transparent financial reporting aligned with international standards such as IFRS and GAAP.',
          'Our accounting and audit services help you optimize tax liabilities, strengthen internal controls, and gain a clear picture of your financial condition.',
          'From bookkeeping to full statutory audits and forensic accounting, we provide the oversight your business needs to operate with confidence.',
        ],
        categories: [
          {
            title: 'Accounting & Compliance',
            icon: 'calculate',
            services: [
              { name: 'Accounting Structure Design', desc: 'Building document cycles and selecting appropriate cloud accounting systems.' },
              { name: 'Bookkeeping', desc: 'Recording daily transactions and auditing journal entries.' },
              { name: 'Periodic Financial Statements', desc: 'Balance sheet, P&L, and cash flow statements — monthly and quarterly.' },
              { name: 'Outsourced CFO', desc: 'Senior financial expertise for startups and SMEs at a flexible cost.' },
              { name: 'Internal Audit & Review', desc: 'Examining records to ensure data accuracy and financial performance integrity.' },
              { name: 'Final Accounts Preparation', desc: 'Preparing files for the annual external audit.' },
            ],
          },
          {
            title: 'Taxation & Zakat',
            icon: 'receipt_long',
            services: [
              { name: 'Value Added Tax (VAT)', desc: 'Registration, filing returns, and compliance consulting.' },
              { name: 'Corporate Tax', desc: 'Compliance with new tax laws — UAE, Egypt, Saudi Arabia, and beyond.' },
              { name: 'Strategic Tax Planning', desc: 'Reducing tax burden within available legal frameworks.' },
              { name: 'Representation before Tax Authorities', desc: 'Handling examination cases, appeals, and objections on your behalf.' },
              { name: 'Transfer Pricing', desc: 'For companies with international branches or affiliated entities.' },
            ],
          },
          {
            title: 'Financial Planning & Investment Strategy',
            icon: 'trending_up',
            services: [
              { name: 'Economic Feasibility Studies', desc: 'Financial and operational analysis for new projects.' },
              { name: 'Budgeting', desc: 'Annual spending plans and budget preparation.' },
              { name: 'Cash Flow Management', desc: 'Ensuring liquidity needed for operations and sustained growth.' },
              { name: 'Business Valuation', desc: 'Determining fair value for sale, merger, or new partner entry.' },
              { name: 'Financial Due Diligence', desc: 'Deep financial review before acquisitions or partnerships.' },
            ],
          },
          {
            title: 'Funding & Growth',
            icon: 'rocket_launch',
            services: [
              { name: 'Capital Structure', desc: 'Balancing self-financing and bank loans for optimal leverage.' },
              { name: 'Bank Financing File Preparation', desc: 'Helping companies obtain loans or bank facilities.' },
              { name: 'Investor Pitch Decks', desc: 'Preparing financial presentations to attract venture capital.' },
              { name: 'IPO & Corporate Transformation', desc: 'Financial aspects of expanding the ownership base and going public.' },
            ],
          },
          {
            title: 'Specialized Services',
            icon: 'real_estate_agent',
            services: [
              { name: 'Real Estate ROI & IRR Analysis', desc: 'Evaluating the feasibility of real estate portfolios.' },
              { name: 'Cost & Project Accounting', desc: 'Especially for construction and real estate development companies.' },
              { name: 'Payroll Services', desc: 'Managing employee entitlements and social insurance.' },
              { name: 'AML Compliance', desc: 'Preparing legally required anti-money-laundering reports and financial policies.' },
              { name: 'Forensic Accounting', desc: 'Investigating embezzlement cases or complex financial disputes.' },
            ],
          },
        ],
        videoSrc: '/media/videos/service-accounting.mp4',
        videoLabel: 'Accounting & Audit Overview',
      },
      {
        title: 'Financing Solutions',
        subtitle: 'Financing',
        heroDesc: 'Every capital need covered — from traditional banking and venture equity to Islamic finance and government grants.',
        details: [
          'Securing the right financing is critical to scaling any business. holol Club provides access to a curated network of lenders, investors, and financial institutions across global markets.',
          'Our financing specialists structure tailored solutions — from working capital facilities and trade finance to private equity placements and project financing — matching your capital needs with the right instruments.',
          'We guide you through the entire journey: from initial feasibility and pitch preparation to term sheets, due diligence, and closing.',
        ],
        categories: [
          {
            title: 'Traditional Banking & Credit',
            icon: 'account_balance',
            services: [
              { name: 'Working Capital Finance', desc: 'Covering daily operational expenses and payroll.' },
              { name: 'Commercial Loans (Long & Short-Term)', desc: 'Financing capital expansions and strategic investments.' },
              { name: 'Credit Facilities (Overdraft)', desc: 'Obtaining immediate liquidity when needed.' },
              { name: 'Asset & Equipment Finance', desc: 'Purchasing machinery or vehicle fleets via installment or financial leasing.' },
              { name: 'International Trade Finance', desc: 'Documentary credits (LCs) and letters of guarantee (LGs).' },
              { name: 'Government-Backed Loans', desc: 'Advisory for low-interest financing through SME support initiatives.' },
            ],
          },
          {
            title: 'Equity & Investment',
            icon: 'trending_up',
            services: [
              { name: 'VC Matchmaking', desc: 'Connecting fast-growing startups with the right venture capital funds.' },
              { name: 'Angel Investor Attraction', desc: 'Securing early-stage funding from individual investors.' },
              { name: 'Private Equity Deal Structuring', desc: 'Bringing in strategic partners in exchange for equity stakes.' },
              { name: 'IPO Preparation', desc: 'Financial and regulatory preparation for stock exchange listing.' },
              { name: 'Mezzanine Finance', desc: 'A hybrid model combining debt and equity for growth-stage companies.' },
            ],
          },
          {
            title: 'Alternative & FinTech',
            icon: 'hub',
            services: [
              { name: 'Crowdfunding', desc: 'Debt-based or equity-based crowdfunding through licensed platforms.' },
              { name: 'Invoice Discounting (Factoring)', desc: 'Immediate liquidity against future receivables from clients.' },
              { name: 'P2P Lending', desc: 'Peer-to-peer financing via licensed digital platforms.' },
              { name: 'Supply Chain Finance', desc: 'Improving cash flows between suppliers and buyers.' },
              { name: 'Microfinance', desc: 'Tailored financing for very small projects and independent professionals.' },
            ],
          },
          {
            title: 'Specialized & Real Estate Finance',
            icon: 'real_estate_agent',
            services: [
              { name: 'Project Finance', desc: 'Financing structured around the project\'s own cash flows.' },
              { name: 'Commercial Mortgage', desc: 'Financing offices, warehouses, or investment land purchases.' },
              { name: 'Financial Leasing', desc: 'Acquiring assets with an option to own at end of term.' },
              { name: 'Sukuk & Bond Issuance', desc: 'Debt instruments for large corporations funding long-term projects.' },
              { name: 'Islamic Finance', desc: 'Murabaha, Musharaka, and Ijara structures — fully Sharia-compliant.' },
            ],
          },
          {
            title: 'Advisory & Financing Readiness',
            icon: 'finance_mode',
            services: [
              { name: 'Debt Restructuring', desc: 'Consolidating existing loans and improving repayment terms and interest rates.' },
              { name: 'Credit Score Improvement', desc: 'Advisory to enhance creditworthiness and bank profile.' },
              { name: 'Financial Modeling for Borrowing', desc: 'Building a financial file that proves the project\'s repayment capacity.' },
              { name: 'Government Grants & Non-Repayable Support', desc: 'Researching available grant programs and support schemes.' },
            ],
          },
        ],
        videoSrc: '/media/videos/service-financing.mp4',
        videoLabel: 'Financing Solutions Overview',
      },
      {
        title: 'Feasibility Studies',
        subtitle: 'Feasibility',
        heroDesc: 'The roadmap that protects investor capital before the first step — C-Suite level analysis covering market, technical, financial, and legal dimensions.',
        details: [
          "Before committing capital, you need clarity. holol Club's feasibility experts conduct rigorous market and financial analyses that give you a definitive answer on whether a project is viable.",
          'Our studies cover demand analysis, competitive landscape mapping, financial projections, risk assessment, and return-on-investment modeling — all tailored to your industry and geography.',
          'Armed with a holol feasibility report, you can approach banks, investors, and regulators with confidence.',
        ],
        categories: [
          {
            title: 'Market Feasibility & Strategic Analysis',
            icon: 'analytics',
            services: [
              { name: 'Demand & Supply Analysis', desc: 'Measuring actual and projected market size and identifying available investment gaps.' },
              { name: 'Competitor Analysis', desc: 'Mapping the strengths and weaknesses of direct and indirect competitors.' },
              { name: 'Consumer Behavior Study', desc: 'Identifying target segments and understanding their preferences and purchasing power.' },
              { name: 'SWOT Analysis', desc: 'Defining the project\'s strengths, weaknesses, opportunities, and threats.' },
              { name: 'PESTEL Analysis', desc: 'Examining the political, economic, social, technological, environmental, and legal landscape.' },
            ],
          },
          {
            title: 'Technical & Engineering Feasibility',
            icon: 'engineering',
            services: [
              { name: 'Optimal Location Study', desc: 'Analyzing proposed sites and selecting the most logistically suitable one.' },
              { name: 'Production / Service Workflow Design', desc: 'Mapping the full operational process from start to finish.' },
              { name: 'Asset & Equipment Requirements', desc: 'Defining machinery, equipment, and technical specifications needed.' },
              { name: 'Human Resources Planning', desc: 'Designing the organizational structure, required roles, and skill sets.' },
              { name: 'Raw Material & Supplier Assessment', desc: 'Identifying supply sources and estimating their costs.' },
            ],
          },
          {
            title: 'Financial Feasibility & Modeling',
            icon: 'price_change',
            services: [
              { name: 'CAPEX Estimation', desc: 'Calculating setup, construction, and asset purchase costs.' },
              { name: 'OPEX Estimation', desc: 'Projecting monthly and annual operating expenses (salaries, rent, utilities).' },
              { name: 'Revenue Model Building', desc: 'Forecasting sales across optimistic, realistic, and pessimistic scenarios.' },
              { name: 'ROI & IRR Analysis', desc: 'Calculating return on investment and internal rate of return.' },
              { name: 'Payback Period Calculation', desc: 'Determining when the project begins to recover its costs.' },
              { name: 'Break-even Point Analysis', desc: 'Identifying the sales volume required to avoid losses.' },
              { name: 'Sensitivity Analysis', desc: 'Testing the project\'s resilience to changes in exchange rates or raw material prices.' },
            ],
          },
          {
            title: 'Specialized Feasibility Studies',
            icon: 'real_estate_agent',
            services: [
              { name: 'Real Estate Feasibility Study', desc: 'Analyzing the optimal use of land and construction projects (holol Real Estate Club focus).' },
              { name: 'Industrial Feasibility Study', desc: 'For projects requiring production lines and complex industrial licenses.' },
              { name: 'Tech Startup Feasibility Study', desc: 'Focusing on scalability, digital market share, and product-market fit.' },
            ],
          },
          {
            title: 'Legal & Risk Assessment',
            icon: 'gavel',
            services: [
              { name: 'Legal & Regulatory Study', desc: 'Identifying required licenses and laws governing the activity.' },
              { name: 'Risk Assessment & Contingency Planning', desc: 'Identifying potential risks and developing proactive mitigation strategies.' },
              { name: 'Environmental & Social Impact Study', desc: 'Ensuring the project aligns with environmental standards and social responsibility.' },
            ],
          },
          {
            title: 'Output & Investment Pitching',
            icon: 'present_to_all',
            services: [
              { name: 'Business Plan Preparation', desc: 'A comprehensive file outlining how to manage and operate the project post-feasibility.' },
              { name: 'Investor Pitch Deck', desc: 'Transforming the feasibility study into a compelling visual presentation to attract funders and partners.' },
            ],
          },
        ],
        videoSrc: '/media/videos/service-feasibility.mp4',
        videoLabel: 'Feasibility Studies Overview',
      },
      {
        title: 'Advertising and Marketing',
        subtitle: 'Marketing',
        heroDesc: 'Turning investor ideas into dominant brands — blending cutting-edge digital solutions with institutional traditional marketing.',
        details: [
          "In a crowded marketplace, your brand is your most powerful asset. holol Club's marketing partners help you craft compelling narratives and deploy them across the right channels to reach your ideal audience.",
          'Our services span brand strategy, digital advertising, social media management, content production, influencer marketing, and performance analytics to provide a comprehensive view of your project.',
          'Whether you are entering a new market or reinforcing an existing presence, we build campaigns tailored specifically for you.',
        ],
        categories: [
          {
            title: 'Branding & Brand Identity',
            icon: 'palette',
            services: [
              { name: 'Full Visual Identity Design', desc: 'Logo, color palette, typography, and official stationery.' },
              { name: 'Brand Story & Positioning', desc: 'Crafting the vision, mission, values, and brand narrative.' },
              { name: 'Brand Guidelines', desc: 'Ensuring consistent brand presentation across every touchpoint.' },
              { name: 'Rebranding', desc: 'Refreshing established companies to align with modern markets.' },
            ],
          },
          {
            title: 'Digital Marketing & Platform Management',
            icon: 'campaign',
            services: [
              { name: 'Social Media Management', desc: 'Facebook, Instagram, LinkedIn, X (Twitter), and TikTok.' },
              { name: 'Paid Advertising Campaigns', desc: 'Maximizing ROI across all digital ad platforms.' },
              { name: 'SEO (Search Engine Optimization)', desc: 'Ranking on the first page of Google for your target keywords.' },
              { name: 'Google Ads', desc: 'Search network, display, and YouTube campaign management.' },
              { name: 'Influencer Marketing', desc: 'Selecting the right personalities per sector for authentic reach.' },
            ],
          },
          {
            title: 'Creative Content Production',
            icon: 'movie',
            services: [
              { name: 'Marketing Copywriting', desc: 'Ads, sales content, and compelling company profiles.' },
              { name: 'Video Production', desc: 'Motion graphics, explainer videos, and promotional films.' },
              { name: 'Professional Photography', desc: 'Products, premises, and corporate team photography.' },
              { name: 'Corporate Podcast Production', desc: 'Positioning the company as a thought leader in its field.' },
            ],
          },
          {
            title: 'PR & Media',
            icon: 'newspaper',
            services: [
              { name: 'Press & Magazine Publications', desc: 'Print and digital news coverage and opinion articles.' },
              { name: 'TV & Radio Appearances', desc: 'Coordinating media interviews to build public credibility.' },
              { name: 'Events & Conference Management', desc: 'Organizing official project launches and corporate events.' },
              { name: 'Crisis Communication Management', desc: 'Protecting brand reputation when issues arise.' },
            ],
          },
          {
            title: 'Direct Marketing & Tech Solutions',
            icon: 'devices',
            services: [
              { name: 'Landing Page Design', desc: 'Conversion-optimized pages for capturing qualified leads.' },
              { name: 'Email Marketing', desc: 'Targeted campaigns and periodic newsletters.' },
              { name: 'WhatsApp Marketing', desc: 'Broadcast campaigns and intelligent automated responses.' },
              { name: 'Website Design & Development', desc: 'Corporate brochure sites and full e-commerce stores.' },
            ],
          },
          {
            title: 'Traditional & Offline Marketing',
            icon: 'location_city',
            services: [
              { name: 'Exhibition Booth Design', desc: 'Creative and impactful trade show presence.' },
              { name: 'Outdoor Advertising', desc: 'Billboards and digital screens in high-traffic locations.' },
              { name: 'Printed Materials & Corporate Gifts', desc: 'Flyers, brochures, and branded merchandise.' },
              { name: 'Market Research & Competitor Analysis', desc: 'Data-driven marketing recommendations for your sector.' },
            ],
          },
        ],
        videoSrc: '/media/videos/service-marketing.mp4',
        videoLabel: 'Marketing & Advertising Overview',
      },
      {
        title: 'Residence & Immigration',
        subtitle: 'Residency & Mobility',
        heroDesc: 'Freedom of movement and investment protection for HNWIs — citizenship, golden visas, and full relocation support across the globe.',
        details: [
          'Relocating or expanding internationally involves navigating complex immigration laws, documentation requirements, and processing timelines. holol Club simplifies this process through a network of accredited immigration specialists.',
          'We offer end-to-end support for investor residency programs, golden visas, skilled worker relocations, family sponsorship, and citizenship-by-investment pathways across multiple jurisdictions.',
          'Our team monitors regulatory changes in real time and ensures that your application is accurate, complete, and submitted at the optimal time.',
        ],
        categories: [
          {
            title: 'Citizenship by Investment (CBI)',
            icon: 'travel_explore',
            services: [
              { name: 'Caribbean Citizenships', desc: 'Dominica, St. Kitts, Antigua, and more — passports granting visa-free access to 140+ countries.' },
              { name: 'Turkish Citizenship', desc: 'Via real estate investment or bank deposit, with full file management from purchase to passport.' },
              { name: 'European Citizenship Programs', desc: 'Malta and other EU programs for investors seeking full EU citizenship rights.' },
              { name: 'Due Diligence File Preparation', desc: 'Ensuring client eligibility and file approval before formal submission.' },
            ],
          },
          {
            title: 'Golden Visas & Permanent Residency',
            icon: 'star',
            services: [
              { name: 'UAE Golden Residency (10 Years)', desc: 'For investors, exceptional talents, and real estate owners.' },
              { name: 'Saudi Premium Residency', desc: 'All tracks: investor, entrepreneur, and exceptional competence.' },
              { name: 'European Golden Visa', desc: 'Greece, Spain, and Portugal — residency with full Schengen freedom of movement.' },
              { name: 'US Investor Program (EB-5)', desc: 'Obtaining a Green Card via investment in USCIS-approved projects.' },
            ],
          },
          {
            title: 'Entrepreneur & Startup Visas',
            icon: 'rocket_launch',
            services: [
              { name: 'UK Innovator Founder Visa', desc: 'For founders looking to establish and grow in the British market.' },
              { name: 'Startup Visa', desc: 'Canada, France, and beyond — for innovators and high-growth businesses.' },
              { name: 'Freelance Visas', desc: 'For international independent professionals and consultants.' },
              { name: 'Digital Nomad Visa', desc: 'For remote workers seeking residency in tourism-friendly or business-hub countries.' },
            ],
          },
          {
            title: 'Professional & Skilled Migration',
            icon: 'workspace_premium',
            services: [
              { name: 'Canadian Immigration (Express Entry)', desc: 'Federal skilled worker and Provincial Nominee Programs (PNP).' },
              { name: 'Global Talent Visa', desc: 'For leaders in technology, arts, and research.' },
              { name: 'EU Blue Card', desc: 'Attracting highly qualified professionals for employment across Europe.' },
              { name: 'Study-to-Migrate Advisory', desc: 'Securing university admission as a pathway to work permits and permanent residency.' },
            ],
          },
          {
            title: 'Legal & Administrative Support',
            icon: 'gavel',
            services: [
              { name: 'Document Apostille & Authentication', desc: 'Embassy procedures and foreign affairs authentication.' },
              { name: 'Certified Legal Translation', desc: 'For all documents required in immigration files.' },
              { name: 'International Criminal Records & Medical Checks', desc: 'Facilitating background and health requirements for immigration.' },
              { name: 'Family Reunification Services', desc: 'Visas for spouse, children, and dependent parents.' },
            ],
          },
          {
            title: 'Relocation & Settlement Services',
            icon: 'home',
            services: [
              { name: 'International Bank Account Opening', desc: 'For non-residents to facilitate investment and fund transfers.' },
              { name: 'Tax Number Registration', desc: 'In the new country of residence for full legal compliance.' },
              { name: 'Residential Property Search', desc: 'Aligned with residency or citizenship investment requirements.' },
              { name: 'School & University Admissions Advisory', desc: 'Securing placements in top international schools at the destination.' },
              { name: 'Soft Landing Services', desc: 'Reception, local ID, driving licence, and health insurance setup.' },
            ],
          },
        ],
        videoSrc: '/media/videos/service-immigration.mp4',
        videoLabel: 'Residence & Immigration Overview',
      },
    ],
    partnerAds: {
      topBanner: {
        videoTitle: 'Join the success partners network at holol Club',
        label: 'Featured Company',
        company: 'AstraMed Group',
        details: 'A healthcare innovation partner driving the expansion of hospital technology across Gulf markets.',
        image:
          'https://images.unsplash.com/photo-1582719508461-905c673771fd?auto=format&fit=crop&w=1200&q=80',
      },
      midBanner: {
        label: 'The countdown has started...',
        company: 'holol Club for Consulting',
        details:
          'A new era of solutions is approaching... we are putting the final touches to deliver an unmatched consulting experience.',
        image:
          'https://dummyimage.com/1200x675/001533/d4af37.png&text=COMING+SOON',
      },
      cardsTitle: 'holol Club at a Glance',
      scrollLeft: 'Scroll Left',
      scrollRight: 'Scroll Right',
    },
    partnersBanner: {
      title: 'Are you ready to go beyond business boundaries?',
      cta: 'Become a Member with Us',
      powerPillarsTitle: 'The Power Pillars',
      powerPillarsSubtitle: 'Three pillars that explain why we are different.',
      powerPillars: [
        {
          title: 'Media power',
          body: 'Continuous presence across three regional TV programs.',
          icon: 'live_tv',
          image:
          'data:image/jpeg;base64,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'
        },
        {
          title: 'Field influence',
          body: 'Exclusive seminars and meetings at leading elite clubs.',
          icon: 'event',
          image:
            'https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=900&q=80',
        },
        {
          title: 'Banking trust',
          body: "Strategic partnerships with major banks to support members' projects.",
          icon: 'account_balance',
          image:
            'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&w=900&q=80',
        },
      ],
      successPartnersTitle: 'Why join holol Club’s success partners?',
      successPartnersSubtitle: 'Three advantages of partnering with us.',
      successPartners: [
        {
          title: 'Professional authority',
          body: 'Build professional authority through television visibility.',
          icon: 'workspace_premium',
          image:
            'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=900&q=80',
        },
        {
          title: 'Targeted clients',
          body: 'Direct access to targeted clients in elite segments.',
          icon: 'hub',
          image:
            'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=900&q=80',
        },
        {
          title: 'Cross-border expansion',
          body: 'Geographic reach across Egypt, the Gulf, and Europe.',
          icon: 'public',
          image:
            'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=900&q=80',
        },
      ],
    },
    agentBenefits: {
      kicker: 'Joining Benefits',
      title: 'Your Business Growth Starts Here... Join Us',
      items: [
        {
          title: 'Benefits of Joining as an Agent',
          intro:
            'Premium media visibility, seminars with elite audiences and investors, a path to global reach, and larger, faster returns — structured in three pillars.',
          sections: [
            {
              heading: 'First: Administrative Benefits.',
              subtitle: 'Exclusive representation and Club-backed operations in your country.',
              points: [
                'The agent is an exclusive representative for managing the Club in the country they represent.',
                'Joining the largest global services app helps the agent grow their business and open new markets.',
              ],
              footerText: 'Ready to submit your official agent application?',
              footerHash: 'registration',
              footerCta: 'Go to registration',
            },
            {
              heading: 'Second: Marketing Benefits.',
              subtitle: 'Official sponsorship, television presence, and seminars that amplify your brand.',
              points: [
                'The agent is a principal and official sponsor in all of the Club\'s marketing campaigns in their represented country.',
                'Hosting on the TV program four times per year.',
                'Hosting at seminars four times per year.',
              ],
              footerText: 'See how we showcase partners in media and at events.',
              footerHash: 'partners-banner',
              footerCta: 'View media pillars',
            },
            {
              heading: 'Third: Financial Benefits.',
              subtitle: 'Revenue share and client flow aligned with sustainable growth.',
              points: [
                'The agent receives 20% of company subscription revenues.',
                'The agent receives 20% of company commissions.',
                'The agent receives at least 250 subscribed clients per year to provide services to them, free of administrative fees or commissions, as a gift from the Club.',
              ],
              footerText: 'Questions about commissions, targets, or next steps?',
              footerHash: 'contact',
              footerCta: 'Contact us',
            },
          ],
          image:
            'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1400&q=80',
        },
        {
          title: 'Benefits of Joining as a Service Provider (Commission Model)',
          intro:
            'Join the elite tier — higher earnings without risk, plus structured support across three pillars.',
          sections: [
            {
              heading: 'First: Administrative Benefits.',
              subtitle: 'Scale through a global app built for businesses and individuals.',
              points: [
                'Joining a global services app for business owners, companies, and individuals helps the company grow, increase the number of clients, and open new markets.',
              ],
              footerText: 'Apply as a service provider and share your company profile.',
              footerHash: 'registration',
              footerCta: 'Go to registration',
            },
            {
              heading: 'Second: Marketing Benefits.',
              subtitle: 'Featured in Club campaigns on the platform and app worldwide.',
              points: [
                'Included in marketing campaigns through the holol Club platform and app globally.',
              ],
              footerText: 'See how partners appear in our media pillars.',
              footerHash: 'partners-banner',
              footerCta: 'View media pillars',
            },
            {
              heading: 'Third: Financial Benefits.',
              subtitle: 'Fair client matching based on your competitive advantages.',
              points: [
                'Clients are referred to the provider based on their competitive advantages compared with competing providers, such as discounts, free services, and more.',
              ],
              footerText: 'Ask about packages for Egypt, the UAE, or Saudi Arabia.',
              footerHash: 'contact',
              footerCta: 'Contact us',
            },
          ],
          image:
            'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1400&q=80',
        },
        {
          title: 'Benefits of Joining as a Service Provider (Subscription Model)',
          intro:
            'Complements the commission model with media visibility tied to subscriptions, events, and guaranteed client flow.',
          sections: [
            {
              heading: 'Media & global campaigns',
              subtitle: 'Scheduled appearances that strengthen your brand.',
              points: [
                'Hosting on the TV program once per year.',
                'Hosting twice in company introductory seminars.',
                'Promotion of the service provider in all Club marketing campaigns worldwide.',
              ],
              footerText: 'Explore our media and event footprint.',
              footerHash: 'partners-banner',
              footerCta: 'View media pillars',
            },
            {
              heading: 'Client referrals',
              subtitle: 'Predictable volume without administrative fees.',
              points: [
                'At least 30 clients per year are referred to the service provider with no administrative fees or commissions.',
              ],
              footerText: 'Discuss targets and subscription scope with our team.',
              footerHash: 'contact',
              footerCta: 'Contact us',
            },
            {
              heading: 'Platform presence',
              subtitle: 'Stand out in the worldwide recommended network.',
              points: [
                'Inclusion in the recommended providers list on the platform and app worldwide as a service provider.',
              ],
              footerText: 'Start your provider application.',
              footerHash: 'registration',
              footerCta: 'Go to registration',
            },
          ],
          image:
            'https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1400&q=80',
        },
        {
          title: 'Benefits of Joining as a Client',
          intro:
            'Save time, cost, and effort — protect your business with an advisor wherever you are. Note: these are some of the free services included for subscribers; additional packages will be announced at launch.',
          sections: [
            {
              heading: 'First: On-Demand Advisory Services.',
              subtitle: 'Fast answers and urgent access when it matters.',
              points: [
                'Chat-based Q&A support with legal/accounting responses within hours.',
                'Emergency calls with a specialized advisor (voice/video) with a monthly allocated number of minutes for urgent cases.',
              ],
              footerText: 'Ask about membership when the Club launches.',
              footerHash: 'contact',
              footerCta: 'Contact us',
            },
            {
              heading: 'Second: Library & Documents.',
              subtitle: 'Templates and reviews that keep you compliant.',
              points: [
                'Ready-to-use contract templates (employment, supply, partnership, lease) that can be downloaded and edited.',
                'Practical accounting templates to manage payroll, cash flow, and budgeting.',
                'Review one or two contracts per month before signing to ensure legal safety.',
              ],
              footerText: 'Browse the advisory areas we cover.',
              footerHash: 'services',
              footerCta: 'View services',
            },
            {
              heading: 'Third: Compliance and Tax Support.',
              subtitle: 'Deadlines, reports, and plain-language updates.',
              points: [
                'Official deadline alerts for tax filings, social insurance, and commercial registration renewals.',
                'Quarterly tax-position checkup reports highlighting expected risks.',
                'Simplified legal updates explaining new regulations and their business impact.',
              ],
              footerText: 'Talk to us about filings and risk reviews.',
              footerHash: 'contact',
              footerCta: 'Contact us',
            },
            {
              heading: 'Fourth: Premium Value-Added Services.',
              subtitle: 'Discounts, integrations, and dispute support.',
              points: [
                'Discounts or special packages for company formation and changing the legal entity.',
                'Integration with accounting systems to track revenues and expenses.',
                'Advisory for amicable arbitration and dispute resolution before going to court.',
              ],
              footerText: 'Further subscription tiers will be announced at launch.',
              footerHash: 'contact',
              footerCta: 'Contact us',
            },
          ],
          image:
            'https://images.unsplash.com/photo-1553729459-efe14ef6055d?auto=format&fit=crop&w=1400&q=80',
        },
      ],
    },
    registration: {
      kicker: 'Join Us',
      title:
        'We connect expertise with real needs... Register your details now to become part of the largest digital advisory community.',
      tabPartner: 'Agent Application',
      tabProvider: 'Service Provider',
      formNext: 'Next',
      formPrevious: 'Previous',
      formStep: 'Step {{n}} of {{t}}',
      submit: 'Submit Application',
      submitting: 'Sending...',
      success: 'Your application has been sent successfully.',
      error: 'Unable to send your application right now. Please try again.',
      missingEndpoint:
        'Form submission is not configured yet. Please set REACT_APP_STATICFORMS_ACCESS_KEY in your environment.',
    },
    contactBanner: {
      title: 'Contact Us',
      subtitle: 'Reach our team directly through email or phone.',
      emailLabel: 'Email',
      emailValue: 'contact@holol.club',
      phoneLabel: 'Phone',
      phoneValue: '+447832180705',
    },
    aboutPage: {
      title: 'Who Are We?',
      introTagline: 'The first digital franchise for consulting and business worldwide.',
      intro:
        'holol Club is a leading digital platform designed to be the first strategic partner for entrepreneurs and companies. We do not provide only consultations; we build an integrated ecosystem that combines deep human expertise with modern technology to provide our clients with a safe, stable environment that drives growth and excellence in local and global markets.',
      visionMessage: {
        title: 'Vision & Mission',
        paragraphs: [
          'To become the most trusted and innovative digital destination in consulting and business, leading the connection between expertise and market needs across Arab and European regions.',
          'We empower founders and companies through smart legal, advisory, and administrative solutions defined by accuracy, speed, and accessibility. We aim to remove administrative friction so our clients can focus on creativity and expansion.',
          'holol Club is a leading international ecosystem that aims to reinvent the consulting sector by combining elite human expertise with artificial intelligence and media reach. We seek to expand across 50 countries, supported by our main hubs in Egypt, Saudi Arabia, and the UAE to deliver cross-border solutions for the business sector.',
        ],
      },
      pillars: {
        title: 'Our Essential Pillars (Why We Are Different)',
        intro:
          'holol Club relies on a golden triangle that gives us an edge over any traditional consulting firm:',
        items: [
          {
            title: 'Media reach',
            body:
              'Strategic partnerships with satellite broadcasters to deliver three specialized TV programs, positioning the Club’s experts as thought leaders in front of millions of viewers.',
          },
          {
            title: 'On-the-ground influence',
            body:
              'Partnerships with leading elite and sports clubs to host live investment seminars that build a real business community.',
          },
          {
            title: 'Banking alliances',
            body:
              'Close cooperation with financial institutions to facilitate financing solutions and support startups and SMEs among Club members.',
          },
        ],
      },
      values: {
        title: 'Our Core Values',
        items: [
          {
            title: 'Reliability',
            body: 'We value information integrity and advisory accuracy as a non-negotiable standard.',
          },
          {
            title: 'Innovation',
            body: 'We leverage technology to develop digital tools that make the entrepreneur journey easier and more efficient.',
          },
          {
            title: 'Partnership',
            body: 'We treat every client as a success partner; their growth is the true measure of our success.',
          },
          {
            title: 'Transparency',
            body: 'We commit to full clarity in all procedures and solutions to build sustainable trust.',
          },
        ],
      },
      specializations: {
        title: 'Consulting Specializations (The Six Pillars)',
        intro:
          'We deliver our services through a select group of accredited service providers in the following areas:',
        items: [
          {
            title: 'Law',
            body: 'Company formation and international commercial disputes.',
          },
          {
            title: 'Accounting',
            body: 'Financial auditing and tax.',
          },
          {
            title: 'Finance',
            body: 'Banking intermediation and investor outreach.',
          },
          {
            title: 'Marketing',
            body: 'Strategic advertising and digital growth.',
          },
          {
            title: 'Feasibility studies',
            body: 'Market analysis and business planning.',
          },
          {
            title: 'Immigration',
            body: 'Residency and citizenship services for investors.',
          },
        ],
      },
      technology: {
        title: 'Technology: AI Partnership (Holol AI Core)',
        intro: 'We use cutting-edge artificial intelligence as a digital operations manager that:',
        items: [
          {
            title: 'Smart matching',
            body: 'Connecting each client to the most suitable expert automatically and with precision.',
          },
          {
            title: 'Data analytics',
            body: 'Forward-looking reports for consultants that safeguard quality and speed of delivery.',
          },
          {
            title: 'Global scale',
            body: 'Managing operations across countries in multiple languages with unified efficiency.',
          },
        ],
      },
      partnership: {
        title: 'Partnership Model (Accredited Service Provider)',
        intro: 'We are not looking for mere vendors—we seek strategic partners who benefit from:',
        items: [
          {
            title: 'A platform of influence',
            body: 'Media and field visibility that strengthens the partner’s brand.',
          },
          {
            title: 'Client flow',
            body: 'A smart referral (leads) system that reaches serious clients from elite segments.',
          },
          {
            title: 'International expansion',
            body: 'The opportunity to enter new markets under the Club’s global umbrella.',
          },
        ],
      },
      objectives: {
        title: 'Our Strategic Objectives',
        items: [
          {
            title: 'Proactive Protection',
            body: 'Provide legal and administrative protection that prevents business risks before they occur.',
          },
          {
            title: 'Digital Consulting Transformation',
            body: 'Transform traditional consulting into an instant and interactive digital experience.',
          },
          {
            title: 'Cross-Border Expansion Support',
            body: 'Facilitate expansion into new Arab and European markets through deep local regulatory understanding.',
          },
          {
            title: 'Immediate Response',
            body: 'Provide rapid support in legal and administrative emergencies to ensure business continuity.',
          },
          {
            title: 'Expert Community Building',
            body: 'Build a network of elite consultants and service providers to deliver unmatched added value.',
          },
        ],
      },
      closing: {
        title: 'In Closing',
        body:
          'holol Club is where technology meets expertise to shape a new future for investment. We are here to turn challenges into opportunities and ideas into tangible, border-crossing reality.',
      },
    },
    footer: {
      tagline: 'The Sovereign Ledger of Business Excellence. Building legacy across borders.',
      navTitle: 'Navigation',
      legalTitle: 'Legal and Privacy',
      hubsTitle: 'Regional Hubs',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      login: 'Member Sign In',
      offices: 'Global Offices',
      copyright:
        'Holol Consulting Club, part of Holol Holding — Dr. Adham El-Sharkawy. All rights reserved.',
      ariaWebsite: 'Website',
      ariaShare: 'Share',
      ariaEmail: 'Email',
      ariaLinkedIn: 'LinkedIn',
      ariaYouTube: 'YouTube',
      ariaTwitter: 'Twitter',
      ariaFacebook: 'Facebook',
    },
    hubs: ['Dubai / DIFC', 'Riyadh / KAFD', 'London / Mayfair', 'New York / Wall St.'],
    founderPage: {
      kicker: 'Founder',
      name: 'Dr. Adham El-Sharkawy',
      role: 'Strategic Expert in Media & Investment Venture Development',
      experienceChip: '25+ years of leadership experience',
      profile: {
        title: 'Professional Profile',
        body:
          'An entrepreneur and strategic concept developer with more than 25 years of experience building and managing major economic entities. Specialized in crafting "strategic alliances" that merge media power, digital solutions, and investment reality. Known for his unique ability to transform complex visions into successful national and regional projects, with a particular focus on the consulting and real-estate sectors.',
        highlights: [
          { icon: 'workspace_premium', label: '25+ Years Experience' },
          { icon: 'hub', label: 'Media × Business Alliances' },
          { icon: 'trending_up', label: 'Consulting & Real Estate' },
          { icon: 'public', label: 'Regional & International Scope' },
        ],
      },
      milestones: {
        title: 'Key Milestones',
        subtitle: 'A career that bridges media power and investment reality',
        items: [
          {
            period: 'CBC TV Channels Group',
            role: 'Director of Media Projects Development',
            icon: 'live_tv',
            points: [
              'Led innovation and investment-content development within one of the largest media groups in the Middle East.',
              'Successfully built a common language between traditional media and the business community, amplifying the group’s influence.',
            ],
          },
          {
            period: '“Mazadat” Project',
            role: 'Founder & Originator',
            icon: 'gavel',
            points: [
              'The visionary and direct manager of the first project merging visual media with real-estate and investment exchange, in partnership with CBC.',
              'Revolutionized the concept of “televised auctions” and turned it into an effective economic tool, with successes documented on-air.',
            ],
          },
          {
            period: 'Banan Group',
            role: 'Institutional Leadership — General Manager',
            icon: 'apartment',
            points: [
              'Banan Integrated Solutions: developing administrative and strategic systems.',
              'Banan Real-Estate Marketing: managing major real-estate portfolios.',
              'Banan Strategic & Marketing Services: brand building and market development.',
            ],
          },
        ],
      },
      mediaSpotlight: {
        kicker: 'Media & presence',
        title: 'Mazadat program',
        subtitle:
          'Mazadat program | Dr. Adham El-Sharkawy on activating the project with Major General Tarek El-Mahdi, Governor of Alexandria.',
        linkHeading: 'Connect with Dr. Adham El-Sharkawy',
        links: [
          { label: 'www.hololrealestate.club', href: 'https://www.hololrealestate.club' },
          { label: 'adhamelsharkawy.com', href: 'https://www.adhamelsharkawy.com/' },
          { label: 'LinkedIn | dr-adhamelsharkawy', href: 'https://www.linkedin.com/in/dr-adhamelsharkawy/' },
          { label: 'YouTube | adhamelsharkaawy', href: 'https://www.youtube.com/@adhamelsharkaawy/' },
          { label: 'Facebook | dr.adhamelsharkaawy', href: 'https://www.facebook.com/dr.adhamelsharkaawy/' },
        ],
        youtubeId: 'eklsLyv3sUc',
      },
      vision: {
        title: 'Current Vision',
        subtitle:
          'Dr. Adham is now channeling his accumulated expertise into founding Holol Holding, which aims to launch:',
        items: [
          {
            title: 'Holol Consulting Club',
            desc: 'The first AI- and media-powered digital consulting franchise.',
            icon: 'hub',
          },
          {
            title: 'Holol Real-Estate Club',
            desc: 'The world’s largest platform for exchanging and managing real-estate services (50 integrated services).',
            icon: 'real_estate_agent',
          },
          {
            title: 'Holol Media',
            desc: 'The media and production arm that will lead investment content across 50 countries.',
            icon: 'campaign',
          },
        ],
      },
      philosophy: {
        title: 'Work Philosophy',
        quote:
          '“Media is not merely a publishing tool — it is the primary engine for managing global ideas and building trust in the markets.”',
      },
      cta: {
        primary: 'Join the Club',
        secondary: 'Back to Home',
      },
    },
  },
  ar: {
    meta: {
      title: 'نادي حلول | حلولك الذكية استشاراتك الناجحة',
      description: 'نادي حلول — حلولك الذكية استشاراتك الناجحة',
    },
    nav: {
      services: 'الخدمات',
      idea: 'فكرتنا',
      about: 'من نحن',
      partners: 'الشركاء',
      contact: 'اتصل بنا',
      joinUs: 'انضم لنا',
      joinPartner: 'انضم لنا',
      founder: 'المؤسس',
      aiAssistant: 'مساعد حلول الذكي',
      switchLang: 'English',
    },
    hero: {
      slogan: 'أول فرنشايز رقمي في العالم',
      slogan2: 'حلولك الذكية استشاراتك الناجحة',
      title1: 'نادي حلول للاستشارات',
      title2:
        'استشارات قانونية، ومحاسبية، وتمويلية، ودعاية وتسويق، ودراسات جدوى، والإقامة والهجرة',
      subtitle:
        'نادي حلول هو الوجهة المفضلة لكبرى الشركات العالمية ولرواد الأعمال والشركات الناشئة، حيث نجمع بين الخبرة القانونية والمالية والاستراتيجية والاستثمارية لدفع نمو أعمالك في قلب الاقتصاد العالمي.',
      ctaPartner: 'انضم لنا',
      ctaProvider: 'أعمالنا السابقة',
      ctaLatestProjects: 'أحدث مشاريعنا',
      statPartners: 'شركاء مميزون',
      statOffices: 'خدمات عالمية',
      statSuccess: 'النجاح مضمون',
      statCapital: 'نمو سريع',
      statBillion: 'مليار+',
      imgAlt:
        'لقطة سينمائية من زاوية منخفضة لناطحات سحاب زجاجية حديثة تمتد إلى سماء ليلية زرقاء مع إضاءة مكاتب ذهبية',
    },
    about: {
      kicker: 'نادي حلول',
      title: 'ملتزمون بالتفرد.',
      p1: 'في نادي حلول، نؤمن بأن النجاح المستدام لا يأتي بالصدفة، بل من خلال التخطيط الاستراتيجي الدقيق والدعم المتكامل. نحن نوفر منصة حصرية تجمع بين الخبرات المحلية والرؤى العالمية.',
      p2: 'نحن الركيزة المؤسسية لأعمالك، نوفر الأدوات والشبكة اللازمة للتنقل بثقة مطلقة بين الأنظمة والقوانين المعقدة لإدارة أعمالك عبر العالم.',
      p3: 'منظومة متكاملة تجمع بين الخبرة المهنية والانتشار الإعلامي والحلول التمويلية والتسويقية في أكثر من 50 دولة، مع مراكز انطلاق في (مصر - السعودية - الإمارات).',
      strategicTitle: 'استراتيجي',
      strategicDesc: 'إطلاق الإمكانات عبر استشارات مصممة خصيصاً لك.',
      globalTitle: 'عالمي',
      globalDesc: 'ربطك بمقدمي خدمات نخبة عبر العالم.',
      cardTitle: 'معيار حلول',
      cardBody:
        'يخضع كل شريك لعملية اختيار صارمة لضمان أعلى مستويات النزاهة والكفاءة المهنية في منظومتنا.',
      cardImgAlt: 'مكتب عصري بجدران رخام بيضاء وعنصر نحتي ذهبي',
      learnMoreText: 'للتعرف علينا أكثر',
      learnMoreCta: 'اعرف المزيد',
    },
    services: {
      kicker: 'نادي حلول',
      title: 'شاركنا الخبرة... انضم لنخبة مقدمي الخدمات',
    },
    serviceItems: [
      {
        title: 'الاستشارات القانونية',
        subtitle: 'قانوني',
        desc: 'أطر قانونية راقية لحماية العقود وحوكمة الشركات.',
      },
      {
        title: 'المحاسبة والمراجعة',
        subtitle: 'محاسبة',
        desc: 'تقارير مالية دقيقة واستراتيجيات تحسين ضريبي.',
      },
      {
        title: 'الحلول التمويلية',
        subtitle: 'تمويل',
        desc: 'الوصول إلى أسواق رأس المال وتسهيلات سيولة مخصصة.',
      },
      {
        title: 'دراسات الجدوى',
        subtitle: 'جدوى',
        desc: 'تحليل سوقي قائم على البيانات و نماذج تنبؤية للمشاريع.',
      },
      {
        title: 'الدعاية والتسويق',
        subtitle: 'تسويق',
        desc: 'انطلاق علامتك التجارية لجمهور عالمي.',
      },
      {
        title: 'الإقامة والهجرة',
        subtitle: 'إقامة وتنقل',
        desc: 'الانتقال السلس عبر العالم من خلال خدمات مميزة.',
      },
    ],
    serviceIcons: ['gavel', 'account_balance_wallet', 'payments', 'analytics', 'campaign', 'travel_explore'],
    serviceSlugs: ['legal', 'accounting', 'financing', 'feasibility', 'marketing', 'immigration'],
    serviceDetails: [
      {
        title: 'الاستشارات القانونية',
        subtitle: 'قانوني',
        heroDesc: 'دعم قانوني شامل للشركات والأفراد في كافة مراحل إنشاء المشروع، من الفكرة إلى التوسع أو التصفية.',
        details: [
          'يوفر فريقنا القانوني دعمًا متكاملًا للشؤون القانونية للشركات، لضمان تشغيل أعمالك بما يتوافق مع القوانين المحلية والدولية.',
          'متخصصون في صياغة العقود والتفاوض عليها، وعمليات الاندماج والاستحواذ، وأطر حوكمة الشركات، وحماية الملكية الفكرية.',
          'سواء كنت تطلق مشروعًا جديدًا، أو تتوسع عبر الحدود، أو تحل نزاعات، تقدم شبكتنا من الخبراء القانونيين المعتمدين حلولًا مخصصة بدقة وسرية تامة.',
        ],
        categories: [
          {
            title: 'أولاً: قطاع تأسيس الشركات والحوكمة',
            icon: 'corporate_fare',
            services: [
              { name: 'تأسيس الشركات', desc: 'شركات الشخص الواحد، المساهمة، ذات المسؤولية المحدودة، واختيار الكيان الأنسب ضريبياً وقانونياً.' },
              { name: 'صياغة النظام الأساسي', desc: 'عقود التأسيس وتعديلاتها بما يضمن حقوق الشركاء.' },
              { name: 'خدمات أمانة سر مجلس الإدارة', desc: 'تنظيم الاجتماعات وصياغة المحاضر الرسمية.' },
              { name: 'اتفاقيات المساهمين', desc: 'لضمان حقوق الأقلية والأغلبية وتخارج الشركاء.' },
              { name: 'خدمات الالتزام والحوكمة', desc: 'مطابقة أعمال الشركة مع القوانين المحلية واللوائح المنظمة.' },
            ],
          },
          {
            title: 'ثانياً: قطاع العقارات والإنشاءات',
            icon: 'real_estate_agent',
            services: [
              { name: 'فحص الملكية (Legal Due Diligence)', desc: 'التحقق من سلامة الأوراق القانونية للعقارات قبل الشراء.' },
              { name: 'تسجيل ونقل الملكية', desc: 'إجراءات التسجيل العقاري والتوثيق الرسمي.' },
              { name: 'عقود المقاولات والإنشاءات', desc: 'صياغة ومراجعة عقود FIDIC والتعامل مع المقاولين والموردين.' },
              { name: 'إدارة النزاعات الإيجارية', desc: 'صياغة عقود الإيجار السكني والتجاري ومتابعة قضايا الإخلاء أو تحصيل المتأخرات.' },
              { name: 'تأسيس الصناديق الاستثمارية العقارية', desc: 'الجوانب القانونية للتمويل والتطوير العقاري.' },
            ],
          },
          {
            title: 'ثالثاً: قطاع العقود والعمليات التجارية',
            icon: 'handshake',
            services: [
              { name: 'صياغة العقود التجارية', desc: 'عقود التوريد والتوزيع والوكالات التجارية والسمسرة.' },
              { name: 'حقوق الامتياز التجاري (Franchise)', desc: 'صياغة عقود الفرنشايز وحماية العلامة التجارية للمانح والممنوح.' },
              { name: 'مراجعة وتدقيق العقود القائمة', desc: 'تقييم المخاطر القانونية في العقود التي وقعها العميل مسبقاً.' },
              { name: 'اتفاقيات السرية وعدم المنافسة (NDA)', desc: 'لحماية أسرار العمل عند التفاوض مع شركاء أو موظفين.' },
            ],
          },
          {
            title: 'رابعاً: قطاع العمل والموارد البشرية',
            icon: 'groups',
            services: [
              { name: 'صياغة عقود العمل', desc: 'بما يتوافق مع قانون العمل المحلي ويحمي صاحب العمل من الثغرات.' },
              { name: 'اللوائح الداخلية للشركات', desc: 'وضع لائحة الجزاءات والمكافآت المعتمدة من وزارة العمل.' },
              { name: 'تمثيل المنشأة في القضايا العمالية', desc: 'أمام المحاكم العمالية ولجان تسوية النزاعات.' },
            ],
          },
          {
            title: 'خامساً: قطاع الملكية الفكرية والتحول الرقمي',
            icon: 'verified',
            services: [
              { name: 'تسجيل العلامات التجارية', desc: 'حماية الملكية الفكرية والنماذج الصناعية.' },
              { name: 'قانون التجارة الإلكترونية', desc: 'صياغة الشروط والأحكام (T&C) وسياسة الخصوصية للمواقع والتطبيقات.' },
            ],
          },
          {
            title: 'سادساً: قطاع التقاضي وتحصيل الديون',
            icon: 'gavel',
            services: [
              { name: 'تحصيل الديون', desc: 'ودياً وقضائياً: توجيه الإنذارات القانونية ومباشرة إجراءات التنفيذ.' },
              { name: 'التمثيل القضائي', desc: 'في القضايا المدنية والتجارية أمام كافة درجات المحاكم.' },
              { name: 'التحكيم والوساطة', desc: 'فض النزاعات بعيداً عن المحاكم لضمان السرعة والسرية.' },
            ],
          },
          {
            title: 'سابعاً: خدمات خاصة للأفراد والنخبة',
            icon: 'stars',
            services: [
              { name: 'تخطيط المواريث والتركات', desc: 'صياغة الوصايا وإدارة انتقال الثروة بين الأجيال (Family Office Support).' },
              { name: 'استشارات الإقامة والجنسية عبر الاستثمار', desc: 'الجوانب القانونية للحصول على إقامات المستثمرين.' },
              { name: 'التدقيق القانوني الشامل للمستثمر', desc: 'تقرير دوري يكشف الثغرات القانونية في استثمارات العميل الحالية.' },
            ],
          },
        ],
        videoSrc: '/media/videos/service-legal.mp4',
        videoLabel: 'نظرة عامة على الاستشارات القانونية',
      },
      {
        title: 'المحاسبة والمراجعة',
        subtitle: 'محاسبة',
        heroDesc: 'لغة الأرقام التي يحتاجها كل مستثمر — تغطي الجوانب التشغيلية اليومية والاستراتيجية الكبرى.',
        details: [
          'يربطك نادي حلول بمحاسبين معتمدين يقدمون تقارير مالية شفافة وفق المعايير الدولية كـ IFRS وGAAP.',
          'تساعدك خدمات المحاسبة والتدقيق لدينا على تحسين الالتزامات الضريبية وتعزيز الضوابط الداخلية والحصول على صورة واضحة عن حالتك المالية.',
          'من مسك الدفاتر إلى التدقيق القانوني الكامل والمحاسبة الجنائية، نوفر الإشراف الذي تحتاجه أعمالك للعمل بثقة.',
        ],
        categories: [
          {
            title: 'أولاً: خدمات المحاسبة والامتثال',
            icon: 'calculate',
            services: [
              { name: 'تصميم الهياكل المحاسبية', desc: 'بناء الدورة المستندية واختيار الأنظمة السحابية (Cloud Accounting) المناسبة.' },
              { name: 'إمساك الدفاتر المحاسبية', desc: 'تسجيل العمليات اليومية وتدقيق القيود.' },
              { name: 'إعداد القوائم المالية الدورية', desc: 'ميزانية، أرباح وخسائر، تدفقات نقدية — شهرياً وربع سنوياً.' },
              { name: 'خدمات المدير المالي الخارجي (Outsourced CFO)', desc: 'توفير خبرة مالية كبرى للشركات الناشئة والمتوسطة بتكلفة مرنة.' },
              { name: 'التدقيق والمراجعة الداخلية', desc: 'فحص السجلات للتأكد من دقة البيانات وسلامة الأداء المالي.' },
              { name: 'إعداد الحسابات الختامية', desc: 'تجهيز الملفات للتدقيق الخارجي السنوي.' },
            ],
          },
          {
            title: 'ثانياً: الخدمات الضريبية والزكاة',
            icon: 'receipt_long',
            services: [
              { name: 'ضريبة القيمة المضافة (VAT)', desc: 'التسجيل، إعداد الإقرارات، وتقديم الاستشارات للامتثال الضريبي.' },
              { name: 'ضريبة الشركات (Corporate Tax)', desc: 'الامتثال للقوانين الضريبية الجديدة خاصة في الإمارات ومصر والسعودية.' },
              { name: 'التخطيط الضريبي الاستراتيجي', desc: 'تقليل العبء الضريبي ضمن الأطر القانونية المتاحة.' },
              { name: 'تمثيل العميل أمام الهيئات الضريبية', desc: 'في حالات الفحص أو الاعتراضات.' },
              { name: 'تسعير التحويل (Transfer Pricing)', desc: 'للشركات التي تملك فروعاً دولية أو شركات شقيقة.' },
            ],
          },
          {
            title: 'ثالثاً: التخطيط المالي والاستثماري',
            icon: 'trending_up',
            services: [
              { name: 'دراسات الجدوى الاقتصادية', desc: 'المالية والتشغيلية للمشاريع الجديدة.' },
              { name: 'إعداد الموازنات التقديرية (Budgeting)', desc: 'وخطط الإنفاق السنوية.' },
              { name: 'إدارة التدفقات النقدية (Cash Flow Management)', desc: 'ضمان السيولة اللازمة للتشغيل والنمو.' },
              { name: 'تقييم الشركات (Business Valuation)', desc: 'لتحديد القيمة العادلة عند البيع أو الاندماج أو دخول شركاء.' },
              { name: 'الفحص المالي النافي للجهالة (Financial Due Diligence)', desc: 'قبل عمليات الاستحواذ أو الشراكة.' },
            ],
          },
          {
            title: 'رابعاً: خدمات التمويل والنمو',
            icon: 'rocket_launch',
            services: [
              { name: 'هيكلة رأس المال', desc: 'التوازن بين التمويل الذاتي والقروض البنكية.' },
              { name: 'تجهيز ملفات التمويل البنكي', desc: 'مساعدة الشركات في الحصول على قروض أو تسهيلات بنكية.' },
              { name: 'إعداد العروض المالية للمستثمرين (Pitch Decks)', desc: 'لجذب رؤوس الأموال الجريئة.' },
              { name: 'إدارة الاكتتابات والتحول لشركات مساهمة', desc: 'الجوانب المالية لتوسيع قاعدة الملكية.' },
            ],
          },
          {
            title: 'خامساً: خدمات متخصصة للواقع العقاري والنخبة',
            icon: 'real_estate_agent',
            services: [
              { name: 'تحليل العائد على الاستثمار العقاري (ROI & IRR)', desc: 'تقييم جدوى المحافظ العقارية.' },
              { name: 'محاسبة التكاليف والمشاريع', desc: 'خاصة لشركات المقاولات والتطوير العقاري.' },
              { name: 'خدمات الرواتب والأجور (Payroll)', desc: 'إدارة مستحقات الموظفين والتأمينات.' },
              { name: 'الامتثال لمكافحة غسيل الأموال (AML)', desc: 'إعداد التقارير والسياسات المالية المطلوبة قانوناً.' },
              { name: 'المحاسبة الجنائية (Forensic Accounting)', desc: 'التحقيق في حالات الاختلاس أو النزاعات المالية المعقدة.' },
            ],
          },
        ],
        videoSrc: '/media/videos/service-accounting.mp4',
        videoLabel: 'نظرة عامة على المحاسبة والمراجعة',
      },
      {
        title: 'الحلول التمويلية',
        subtitle: 'تمويل',
        heroDesc: 'تغطية شاملة لكل احتياجات رأس المال — من التمويل المصرفي التقليدي ورأس المال الجريء إلى التمويل الإسلامي والمنح الحكومية.',
        details: [
          'يُعدّ تأمين التمويل المناسب أمرًا بالغ الأهمية لتوسيع نطاق أي عمل تجاري. يمنحك نادي حلول إمكانية الوصول إلى شبكة منتقاة من المقرضين والمستثمرين والمؤسسات المالية في الأسواق العالمية.',
          'يقوم خبراء التمويل لدينا بهيكلة حلول مخصصة — من تسهيلات رأس المال العامل وتمويل التجارة إلى عروض الأسهم الخاصة وتمويل المشاريع — لمطابقة احتياجاتك من رأس المال مع الأدوات المناسبة.',
          'نرشدك في كامل الرحلة: من الجدوى الأولية وإعداد العروض التقديمية إلى صحائف الشروط والعناية الواجبة وإتمام الصفقات.',
        ],
        categories: [
          {
            title: 'أولاً: التمويل المصرفي والائتماني',
            icon: 'account_balance',
            services: [
              { name: 'تمويل رأس المال العامل', desc: 'لتغطية المصاريف التشغيلية اليومية والرواتب.' },
              { name: 'القروض التجارية (طويلة وقصيرة الأجل)', desc: 'لتمويل التوسعات الرأسمالية والاستثمارات الاستراتيجية.' },
              { name: 'التسهيلات الائتمانية (Overdraft)', desc: 'للحصول على سيولة فورية عند الحاجة.' },
              { name: 'تمويل الأصول والمعدات', desc: 'لشراء الماكينات أو أساطيل النقل بنظام التقسيط أو التأجير التمويلي.' },
              { name: 'تمويل التجارة الدولية', desc: 'الاعتمادات المستندية (LCs) وخطابات الضمان (LGs).' },
              { name: 'القروض المدعومة حكومياً', desc: 'استشارات للحصول على تمويلات بأسعار فائدة منخفضة من مبادرات دعم المشروعات الصغيرة.' },
            ],
          },
          {
            title: 'ثانياً: تمويل الاستثمار والملكية',
            icon: 'trending_up',
            services: [
              { name: 'الربط مع رأس المال الجريء (VC Matchmaking)', desc: 'للشركات الناشئة ذات النمو السريع.' },
              { name: 'استقطاب المستثمرين الملائكيين', desc: 'للمشاريع في مراحلها الأولى.' },
              { name: 'هيكلة صفقات الملكية الخاصة (Private Equity)', desc: 'لدخول شركاء استراتيجيين مقابل حصص.' },
              { name: 'إعداد ملفات الطرح الأولي (IPO Preparation)', desc: 'للشركات الراغبة في الإدراج بالبورصة.' },
              { name: 'التمويل الميزانيني (Mezzanine Finance)', desc: 'نموذج يجمع بين الدين والملكية لشركات مرحلة النمو.' },
            ],
          },
          {
            title: 'ثالثاً: التمويل البديل والتقني',
            icon: 'hub',
            services: [
              { name: 'التمويل الجماعي (Crowdfunding)', desc: 'سواء بنظام الدين أو مقابل حصص في الملكية عبر منصات معتمدة.' },
              { name: 'خصم الفواتير (Factoring)', desc: 'الحصول على سيولة فورية مقابل المستحقات الآجلة لدى العملاء.' },
              { name: 'التمويل من نظير لنظير (P2P Lending)', desc: 'عبر المنصات الرقمية المعتمدة.' },
              { name: 'تمويل سلسلة التوريد (Supply Chain Finance)', desc: 'لتحسين التدفقات النقدية بين الموردين والمشترين.' },
              { name: 'التمويل متناهي الصغر (Microfinance)', desc: 'للمشاريع الصغيرة جداً والمهنيين المستقلين.' },
            ],
          },
          {
            title: 'رابعاً: التمويل المتخصص والعقاري',
            icon: 'real_estate_agent',
            services: [
              { name: 'تمويل المشاريع الكبرى (Project Finance)', desc: 'تمويل يعتمد على التدفقات النقدية للمشروع نفسه.' },
              { name: 'الرهن العقاري التجاري', desc: 'لتمويل شراء المقرات أو المستودعات أو الأراضي الاستثمارية.' },
              { name: 'التأجير التمويلي (Leasing)', desc: 'الحصول على الأصول مع خيار التملك في نهاية المدة.' },
              { name: 'إصدار السكوك والسندات', desc: 'كأدوات دين للشركات الكبرى لتمويل مشاريع طويلة الأمد.' },
              { name: 'التمويل الإسلامي', desc: 'المرابحة، المشاركة، والإجارة — هياكل متوافقة مع الشريعة الإسلامية.' },
            ],
          },
          {
            title: 'خامساً: الاستشارات والجاهزية التمويلية',
            icon: 'finance_mode',
            services: [
              { name: 'إعادة هيكلة الديون', desc: 'دمج القروض الحالية وتحسين شروط السداد والفوائد.' },
              { name: 'تحسين التصنيف الائتماني (Credit Score)', desc: 'استشارات لرفع كفاءة الملف الائتماني أمام البنوك.' },
              { name: 'إعداد النمذجة المالية للاقتراض', desc: 'بناء ملف مالي يثبت قدرة المشروع على السداد.' },
              { name: 'استشارات المنح الحكومية والدعم غير المسترد', desc: 'البحث عن برامج الدعم والمنح المتاحة في الدولة.' },
            ],
          },
        ],
        videoSrc: '/media/videos/service-financing.mp4',
        videoLabel: 'نظرة عامة على الحلول التمويلية',
      },
      {
        title: 'دراسات الجدوى',
        subtitle: 'جدوى',
        heroDesc: 'خريطة الطريق التي تحمي رؤوس أموال المستثمرين قبل البدء — تحليل بمستوى C-Suite يغطي الجوانب التسويقية والفنية والمالية والقانونية.',
        details: [
          'قبل تخصيص رأس المال، تحتاج إلى وضوح تام. يُجري خبراء الجدوى في نادي حلول تحليلات سوقية ومالية صارمة تمنحك إجابة قاطعة حول جدوى المشروع.',
          'تشمل دراساتنا تحليل الطلب ورسم خريطة المشهد التنافسي والتوقعات المالية وتقييم المخاطر ونمذجة العائد على الاستثمار — مصممة جميعها وفق قطاعك وموقعك الجغرافي.',
          'بفضل تقرير جدوى نادي حلول، يمكنك التعامل مع البنوك والمستثمرين والجهات التنظيمية بثقة تامة.',
        ],
        categories: [
          {
            title: 'أولاً: دراسات السوق والتحليل الاستراتيجي',
            icon: 'analytics',
            services: [
              { name: 'تحليل الطلب والعرض', desc: 'دراسة حجم السوق الفعلي والمتوقع والفجوات الاستثمارية المتاحة.' },
              { name: 'تحليل المنافسين (Competitor Analysis)', desc: 'دراسة نقاط القوة والضعف للمنافسين المباشرين وغير المباشرين.' },
              { name: 'دراسة سلوك المستهلك', desc: 'تحديد الفئات المستهدفة وفهم تفضيلاتهم وقدراتهم الشرائية.' },
              { name: 'تحليل SWOT', desc: 'تحديد نقاط القوة والضعف والفرص والتهديدات الخاصة بالمشروع.' },
              { name: 'تحليل PESTEL', desc: 'دراسة الظروف السياسية، الاقتصادية، الاجتماعية، التقنية، البيئية، والقانونية المحيطة.' },
            ],
          },
          {
            title: 'ثانياً: الدراسة الفنية والهندسية',
            icon: 'engineering',
            services: [
              { name: 'تحديد الموقع الأمثل', desc: 'دراسة وتحليل المواقع المقترحة واختيار الأنسب لوجستياً.' },
              { name: 'توصيف العملية الإنتاجية/الخدمية', desc: 'رسم مسار تدفق العمل (Workflow) من البداية للنهاية.' },
              { name: 'تقدير الاحتياجات من الأصول', desc: 'تحديد الآلات، المعدات، والأجهزة المطلوبة ومواصفاتها الفنية.' },
              { name: 'تخطيط الموارد البشرية', desc: 'تحديد الهيكل التنظيمي، الوظائف المطلوبة، والمهارات اللازمة.' },
              { name: 'تقدير احتياجات المواد الخام والموردين', desc: 'تحديد مصادر الإمداد وتكلفتها التقديرية.' },
            ],
          },
          {
            title: 'ثالثاً: الدراسة المالية والنمذجة',
            icon: 'price_change',
            services: [
              { name: 'تقدير التكاليف الرأسمالية (CAPEX)', desc: 'حساب تكاليف التأسيس والإنشاءات وشراء الأصول.' },
              { name: 'تقدير التكاليف التشغيلية (OPEX)', desc: 'حساب المصاريف الشهرية والسنوية من رواتب وإيجارات ومرافق.' },
              { name: 'بناء نماذج الإيرادات', desc: 'توقع المبيعات بناءً على سيناريوهات متفائل، واقعي، ومتشائم.' },
              { name: 'تحليل المؤشرات المالية (ROI & IRR)', desc: 'حساب العائد على الاستثمار ومعدل العائد الداخلي.' },
              { name: 'حساب فترة استرداد رأس المال (Payback Period)', desc: 'متى سيبدأ المشروع في تغطية تكاليفه؟' },
              { name: 'تحليل نقطة التعادل (Break-even Point)', desc: 'تحديد حجم المبيعات اللازم لتجنب الخسارة.' },
              { name: 'تحليل الحساسية (Sensitivity Analysis)', desc: 'اختبار مدى تأثر المشروع بتغير أسعار الصرف أو المواد الخام.' },
            ],
          },
          {
            title: 'رابعاً: دراسات الجدوى المتخصصة',
            icon: 'real_estate_agent',
            services: [
              { name: 'دراسة الجدوى العقارية', desc: 'تحليل الاستخدام الأمثل للأراضي والمشاريع الإنشائية (النادي العقاري).' },
              { name: 'دراسة الجدوى الصناعية', desc: 'للمشاريع التي تتطلب خطوط إنتاج وتراخيص صناعية معقدة.' },
              { name: 'دراسة الجدوى للمشاريع التقنية (Startups)', desc: 'تركز على القابلية للتوسع (Scalability) وحصة السوق الرقمية.' },
            ],
          },
          {
            title: 'خامساً: الجوانب القانونية وتقييم المخاطر',
            icon: 'gavel',
            services: [
              { name: 'الدراسة القانونية والتشريعية', desc: 'تحديد التراخيص المطلوبة والقوانين المنظمة للنشاط.' },
              { name: 'تقييم المخاطر وخطط الطوارئ', desc: 'تحديد المخاطر المحتملة ووضع حلول استباقية لها.' },
              { name: 'دراسة الأثر البيئي والاجتماعي', desc: 'ضمان توافق المشروع مع المعايير البيئية والمسؤولية المجتمعية.' },
            ],
          },
          {
            title: 'سادساً: مخرجات التطوير والاستثمار',
            icon: 'present_to_all',
            services: [
              { name: 'إعداد خطة العمل (Business Plan)', desc: 'ملف شامل يوضح كيفية إدارة وتشغيل المشروع بعد الجدوى.' },
              { name: 'تجهيز ملف عرض المستثمر (Investor Pitch Deck)', desc: 'تحويل دراسة الجدوى إلى عرض بصري جذاب لإقناع الممولين والشركاء.' },
            ],
          },
        ],
        videoSrc: '/media/videos/service-feasibility.mp4',
        videoLabel: 'نظرة عامة على دراسات الجدوى',
      },
      {
        title: 'الدعاية والتسويق',
        subtitle: 'تسويق',
        heroDesc: 'تحويل أفكار المستثمرين إلى علامات تجارية مسيطرة — بدمج الحلول الرقمية الحديثة والحلول التقليدية المؤسسية.',
        details: [
          'في سوق مزدحم، علامتك التجارية هي أقوى أصولك. يساعدك شركاء التسويق في نادي حلول على صياغة رسائل مقنعة ونشرها عبر القنوات المناسبة للوصول إلى جمهورك المستهدف.',
          'تشمل خدماتنا استراتيجية العلامة التجارية والإعلان الرقمي وإدارة وسائل التواصل الاجتماعي وإنتاج المحتوى والتسويق عبر المؤثرين وتحليلات الأداء  لتوفير رؤية شاملة لمشروعك.',
          'سواء كنت تدخل سوقًا جديدًا أو تعزز حضورًا قائمًا، نبني حملات مصممة خصيصا لك.',
        ],
        categories: [
          {
            title: 'أولاً: بناء الهوية والعلامة التجارية',
            icon: 'palette',
            services: [
              { name: 'تصميم الهوية البصرية كاملة', desc: 'الشعار، الألوان، الخطوط، والأوراق الرسمية.' },
              { name: 'صياغة قصة العلامة التجارية (Brand Story)', desc: 'صياغة الرؤية والرسالة والقيم.' },
              { name: 'بناء الأدلة الإرشادية (Brand Guidelines)', desc: 'لضمان توحيد شكل العلامة في كل مكان.' },
              { name: 'خدمات إعادة تسمية العلامة (Rebranding)', desc: 'لتطوير الشركات القديمة لتواكب العصر.' },
            ],
          },
          {
            title: 'ثانياً: التسويق الرقمي وإدارة المنصات',
            icon: 'campaign',
            services: [
              { name: 'إدارة حسابات التواصل الاجتماعي', desc: 'فيسبوك، إنستجرام، لينكد إن، تويتر، تيك توك.' },
              { name: 'إدارة الحملات الإعلانية الممولة', desc: 'لتحقيق أعلى عائد على الإنفاق الإعلاني عبر كافة المنصات.' },
              { name: 'تحسين محركات البحث (SEO)', desc: 'لضمان ظهور موقع العميل في النتائج الأولى في جوجل.' },
              { name: 'إعلانات جوجل (Google Ads)', desc: 'حملات الظهور على شبكة البحث واليوتيوب.' },
              { name: 'التسويق عبر المؤثرين', desc: 'اختيار الشخصيات المناسبة لكل قطاع لضمان المصداقية.' },
            ],
          },
          {
            title: 'ثالثاً: إنتاج المحتوى الإبداعي',
            icon: 'movie',
            services: [
              { name: 'صياغة المحتوى التسويقي (Copywriting)', desc: 'كتابة الإعلانات، المحتوى البيعي، والبروفايلات.' },
              { name: 'إنتاج الفيديوهات الدعائية', desc: 'Motion Graphics، Explainer Videos، وأفلام ترويجية.' },
              { name: 'التصوير الفوتوغرافي الاحترافي', desc: 'للمنتجات، المقرات، وفريق العمل.' },
              { name: 'إنتاج البودكاست المؤسسي', desc: 'لتعزيز مكانة الشركة كخبير في تخصصها.' },
            ],
          },
          {
            title: 'رابعاً: العلاقات العامة والظهور الإعلامي',
            icon: 'newspaper',
            services: [
              { name: 'النشر في الصحف والمجلات', desc: 'الورقية والإلكترونية كأخبار رسمية أو مقالات رأي.' },
              { name: 'تنسيق اللقاءات التلفزيونية والإذاعية', desc: 'لزيادة موثوقية العميل أمام الجمهور.' },
              { name: 'تنظيم الفعاليات والمؤتمرات', desc: 'وإدارة حفلات الإطلاق الرسمي للمشاريع.' },
              { name: 'إدارة الأزمات الإعلامية', desc: 'لحماية سمعة العلامة التجارية عند وقوع أي مشكلة.' },
            ],
          },
          {
            title: 'خامساً: الحلول التقنية والتسويق المباشر',
            icon: 'devices',
            services: [
              { name: 'تصميم صفحات الهبوط (Landing Pages)', desc: 'المخصصة لجمع بيانات العملاء (Leads).' },
              { name: 'التسويق عبر البريد الإلكتروني', desc: 'والنشرات الإخبارية الدورية للعملاء.' },
              { name: 'خدمات التسويق عبر الواتساب', desc: 'والردود الآلية الذكية.' },
              { name: 'تصميم وتطوير المواقع الإلكترونية', desc: 'التعريفية أو المتاجر الرقمية.' },
            ],
          },
          {
            title: 'سادساً: التسويق التقليدي والميداني',
            icon: 'location_city',
            services: [
              { name: 'تصميم وتنفيذ أجنحة المعارض', desc: 'بشكل مبتكر وجذاب.' },
              { name: 'إعلانات الطرق (Outdoors)', desc: 'اللوحات الإعلانية والشاشات في الميادين الكبرى.' },
              { name: 'المطبوعات الدعائية وهدايا الشركات', desc: 'Flyers، Brochures، وهدايا مؤسسية.' },
              { name: 'دراسات السوق وتحليل المنافسين', desc: 'لتقديم توصيات تسويقية مبنية على بيانات حقيقية.' },
            ],
          },
        ],
        videoSrc: '/media/videos/service-marketing.mp4',
        videoLabel: 'نظرة عامة على الدعاية والتسويق',
      },
      {
        title: 'الإقامة والهجرة',
        subtitle: 'إقامة وتنقل',
        heroDesc: 'حرية الحركة وحماية الاستثمار لأصحاب الثروات — جنسيات، إقامات ذهبية، ودعم انتقال شامل حول العالم.',
        details: [
          'يستلزم الانتقال أو التوسع دوليًا التعامل مع قوانين هجرة معقدة ومتطلبات توثيق مختلفة. يبسّط نادي حلول هذه العملية من خلال شبكة من المتخصصين المعتمدين في الهجرة.',
          'نقدم دعمًا شاملًا لبرامج الإقامة للمستثمرين والتأشيرات الذهبية وانتقال العمالة الماهرة وكفالة الأسرة ومسارات الجنسية عن طريق الاستثمار عبر ولايات قضائية متعددة.',
          'يرصد فريقنا التغييرات التنظيمية في الوقت الفعلي ويضمن أن طلبك دقيق وكامل ومقدَّم في الوقت الأمثل.',
        ],
        categories: [
          {
            title: 'أولاً: برامج الجنسية عبر الاستثمار (CBI)',
            icon: 'travel_explore',
            services: [
              { name: 'جنسيات الكاريبي', desc: 'دومينيكا، سانت كيتس، أنتيغوا وغيرها — جواز سفر يتيح دخول أكثر من 140 دولة بدون تأشيرة.' },
              { name: 'الجنسية التركية', desc: 'عبر الاستثمار العقاري أو الوديعة البنكية، مع إدارة كاملة للملف من الشراء حتى الاستلام.' },
              { name: 'برامج الجنسية الأوروبية', desc: 'مالطا وغيرها للمستثمرين الراغبين في حقوق المواطنة الكاملة داخل الاتحاد الأوروبي.' },
              { name: 'تجهيز ملفات التقصي الأمني (Due Diligence)', desc: 'لضمان قبول ملف العميل قبل التقديم الرسمي.' },
            ],
          },
          {
            title: 'ثانياً: الإقامات الذهبية والدائمة',
            icon: 'star',
            services: [
              { name: 'الإقامة الذهبية الإماراتية (10 سنوات)', desc: 'للمستثمرين، النوابغ، وأصحاب العقارات.' },
              { name: 'الإقامة المميزة السعودية', desc: 'بكافة مساراتها: مستثمر، رائد أعمال، كفاءة استثنائية.' },
              { name: 'الإقامة الذهبية الأوروبية', desc: 'اليونان، إسبانيا، البرتغال — الإقامة وحرية التنقل في منطقة الشنغن.' },
              { name: 'برنامج المستثمر الأمريكي (EB-5)', desc: 'للحصول على الجرين كارد عبر الاستثمار في مشاريع معتمدة من USCIS.' },
            ],
          },
          {
            title: 'ثالثاً: تأشيرات رواد الأعمال والشركات الناشئة',
            icon: 'rocket_launch',
            services: [
              { name: 'تأشيرة رائد الأعمال البريطانية (UK Innovator Founder)', desc: 'للمؤسسين الراغبين في التوسع في السوق البريطاني.' },
              { name: 'تأشيرة الشركات الناشئة (Start-up Visa)', desc: 'في دول مثل كندا أو فرنسا لجذب المبتكرين.' },
              { name: 'تأشيرات العمل الحر (Freelance Visas)', desc: 'للمهنيين والمستشارين الدوليين المستقلين.' },
              { name: 'تأشيرة الرحالة الرقميين (Digital Nomad Visa)', desc: 'لمن يعملون عن بُعد ويرغبون في الإقامة في دول سياحية أو تجارية.' },
            ],
          },
          {
            title: 'رابعاً: خدمات الهجرة المهنية والتخصصية',
            icon: 'workspace_premium',
            services: [
              { name: 'برامج الهجرة الكندية (Express Entry)', desc: 'وبرامج الترشيح الإقليمي (PNP).' },
              { name: 'تأشيرة المواهب العالمية (Global Talent)', desc: 'للمتميزين في مجالات التكنولوجيا، الفن، والبحث العلمي.' },
              { name: 'البطاقة الزرقاء الأوروبية (EU Blue Card)', desc: 'لاستقطاب الكفاءات المهنية العالية للعمل في أوروبا.' },
              { name: 'استشارات الدراسة للهجرة', desc: 'تأمين القبول الجامعي كمدخل للحصول على إقامة العمل ثم الدائمة.' },
            ],
          },
          {
            title: 'خامساً: الدعم القانوني والإجرائي',
            icon: 'gavel',
            services: [
              { name: 'تصديق وتوثيق المستندات (Apostille)', desc: 'وإنهاء إجراءات السفارات والخارجية.' },
              { name: 'الترجمة القانونية المعتمدة', desc: 'لكافة الوثائق المطلوبة في ملفات الهجرة.' },
              { name: 'استخراج السجلات الجنائية الدولية والفحوصات الطبية', desc: 'وتسهيل الإجراءات الصحية المطلوبة للهجرة.' },
              { name: 'خدمات لم الشمل', desc: 'استخراج تأشيرات الزوجة، الأبناء، والوالدين التابعين للمستثمر.' },
            ],
          },
          {
            title: 'سادساً: خدمات الاستقرار والدمج',
            icon: 'home',
            services: [
              { name: 'فتح الحسابات البنكية الدولية', desc: 'لغير المقيمين لتسهيل تحويل مبالغ الاستثمار.' },
              { name: 'استخراج الأرقام الضريبية', desc: 'في بلد الإقامة الجديد لضمان الامتثال القانوني.' },
              { name: 'البحث عن العقار السكني', desc: 'بما يتوافق مع شروط الإقامة أو الجنسية.' },
              { name: 'الاستشارات المدرسية والجامعية', desc: 'لتأمين قبول الأبناء في أفضل المدارس الدولية ببلد المقصد.' },
              { name: 'خدمات الهبوط الناعم (Soft Landing)', desc: 'الاستقبال، استخراج الهوية المحلية، رخصة القيادة، والتأمين الصحي.' },
            ],
          },
        ],
        videoSrc: '/media/videos/service-immigration.mp4',
        videoLabel: 'نظرة عامة على الإقامة والهجرة',
      },
    ],
    partnerAds: {
      topBanner: {
        videoTitle: 'انضم إلى شبكة شركاء النجاح في نادي حلول',
        label: 'شركة مميزة',
        company: 'أستراميد جروب',
        details: 'شريك ابتكار صحي يقود توسع تقنيات المستشفيات في أسواق الخليج.',
        image:
          'https://images.unsplash.com/photo-1582719508461-905c673771fd?auto=format&fit=crop&w=1200&q=80',
      },
      midBanner: {
        label: 'العد التنازلي بدأ...',
        company: 'نادي حلول للاستشارات',
        details: 'عصر جديد من الحلول يقترب... نضع اللمسات الأخيرة لنقدم لكم تجربة استشارية لا مثيل لها',
        image:
          'https://dummyimage.com/1200x675/001533/d4af37.png&text=COMING+SOON',
      },
      cardsTitle: 'نادي حلول في سطور',
      scrollLeft: 'التمرير لليسار',
      scrollRight: 'التمرير لليمين',
    },
    partnersBanner: {
      title: 'هل أنت مستعد لتجاوز حدود الأعمال؟',
      cta: 'كن عضواً معنا',
      powerPillarsTitle: 'ركائز قوة نادي حلول',
      powerPillarsSubtitle: 'ثلاث ركائز تشرح لماذا نحن مختلفون.',
      powerPillars: [
        {
          title: 'القوة الإعلامية',
          body: 'تواجد مستمر في 3 برامج تلفزيونية إقليمية.',
          icon: 'live_tv',
          image:
          'data:image/jpeg;base64,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'
        },
        {
          title: 'النفوذ الميداني',
          body: 'ندوات ولقاءات حصرية في أكبر أندية النخبة.',
          icon: 'event',
          image:
            'https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=900&q=80',
        },
        {
          title: 'الثقة المصرفية',
          body: 'شراكات استراتيجية مع كبرى البنوك لدعم مشاريع أعضائنا.',
          icon: 'account_balance',
          image:
            'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&w=900&q=80',
        },
      ],
      successPartnersTitle: 'لماذا تنضم لشركاء النجاح في نادي حلول؟',
      successPartnersSubtitle: 'ثلاث مزايا للشراكة معنا.',
      successPartners: [
        {
          title: 'سلطة مهنية',
          body: 'بناء سلطة مهنية من خلال الظهور التلفزيوني.',
          icon: 'workspace_premium',
          image:
            'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=900&q=80',
        },
        {
          title: 'عملاء مستهدفون',
          body: 'وصول مباشر لعملاء مستهدفين من فئة النخبة.',
          icon: 'hub',
          image:
            'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=900&q=80',
        },
        {
          title: 'توسع جغرافي',
          body: 'التوسع الجغرافي العابر للحدود (مصر، الخليج، أوروبا).',
          icon: 'public',
          image:
            'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=900&q=80',
        },
      ],
    },
    agentBenefits: {
      kicker: 'مميزات الانضمام',
      title: 'نمو أعمالك يبدأ من هنا... انضم إلينا',
      items: [
        {
          title: 'مميزات الانضمام كوكيل',
          intro:
            'ظهور إعلامي مميز، ندوات مع النخبة والمستثمرين، انطلاق نحو العالمية، وأرباح أكبر وأسرع في ثلاث ركائز.',
          sections: [
            {
              heading: 'أولاً: المميزات الإدارية.',
              subtitle: 'تمثيل حصري ودعم تشغيلي للنادي ضمن سوقك.',
              points: [
                'يكون الوكيل وكيلاً حصرياً في إدارة النادي في البلد التي يمثلها.',
                'الانضمام إلى أكبر تطبيق عالمي لتقديم الخدمات مما يساعد على نمو أعمال الوكيل وفتح أسواق جديدة له.',
              ],
              footerText: 'جاهز لتقديم طلب الوكيل الرسمي؟',
              footerHash: 'registration',
              footerCta: 'الانتقال إلى التسجيل',
            },
            {
              heading: 'ثانياً: المميزات التسويقية.',
              subtitle: 'رعاية رسمية وحضور إعلامي وندوات تعزز علامتك.',
              points: [
                'يكون الوكيل راعياً رئيسياً ورسمياً في كل وسائل الدعاية التسويقية التي يقوم بها النادي في البلد التي يمثلها.',
                'الاستضافة في البرنامج التلفزيوني أربع مرات سنوياً.',
                'الاستضافة في الندوات أربع مرات سنوياً.',
              ],
              footerText: 'اطلع على ركائز القوة الإعلامية والظهور في الفعاليات.',
              footerHash: 'partners-banner',
              footerCta: 'عرض ركائز القوة',
            },
            {
              heading: 'ثالثاً: المميزات المالية.',
              subtitle: 'حصص إيرادات وتدفق عملاء يدعم نموك المستدام.',
              points: [
                'يحصل الوكيل على 20% من اشتراكات الشركات.',
                'يحصل الوكيل على 20% من عمولات الشركات.',
                'يحصل الوكيل على ما لا يقل عن 250 عميلاً مشتركاً سنوياً لأداء الخدمة لهم دون أي مصاريف إدارية أو عمولات، كهدية من النادي.',
              ],
              footerText: 'للاستفسار حول العمولات والأهداف أو الخطوات التالية.',
              footerHash: 'contact',
              footerCta: 'تواصل معنا',
            },
          ],
          image:
            'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1400&q=80',
        },
        {
          title: 'مميزات الانضمام كمقدم خدمة بنظام العمولة',
          intro: 'الانضمام إلى الصفوة — أرباح أكثر - بدون مخاطرة - مع دعم منظم في ثلاث ركائز.',
          sections: [
            {
              heading: 'أولاً: المميزات الإدارية.',
              subtitle: 'التوسع عبر تطبيق عالمي لخدمة الشركات والأفراد.',
              points: [
                'الانضمام إلى تطبيق عالمي لتقديم الخدمات الخاصة لرجال الأعمال وللشركات والأفراد يساعد على نمو الشركة وزيادة عدد المتعاملين معها وكذلك فتح أسواق جديدة للشركة.',
              ],
              footerText: 'قدّم طلبك كمقدم خدمة وصف شركتك.',
              footerHash: 'registration',
              footerCta: 'الانتقال إلى التسجيل',
            },
            {
              heading: 'ثانياً: المميزات التسويقية.',
              subtitle: 'ظهور ضمن حملات النادي على المنصة والتطبيق عالمياً.',
              points: [
                'إدراج مقدم الخدمة ضمن الحملات التسويقية عبر منصة وتطبيق نادي حلول على مستوى العالم.',
              ],
              footerText: 'اطلع على ركائز الظهور الإعلامي.',
              footerHash: 'partners-banner',
              footerCta: 'عرض ركائز القوة',
            },
            {
              heading: 'ثالثاً: المميزات المالية.',
              subtitle: 'توجيه العملاء وفق ميزتك التنافسية.',
              points: [
                'يُوجَّه العملاء إلى مقدم الخدمة وفق ميزته التنافسية مقارنةً بمقدمي الخدمة المنافسين، مثل الخصومات والخدمات المجانية وغيرها.',
              ],
              footerText: 'استفسر عن الباقات في مصر أو الإمارات أو السعودية.',
              footerHash: 'contact',
              footerCta: 'تواصل معنا',
            },
          ],
          image:
            'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1400&q=80',
        },
        {
          title: 'الانضمام كمقدم خدمة بنظام الاشتراك',
          intro:
            'يُكمِّل نموذج العمولة بظهور إعلامي مرتبط بالاشتراكات، وفعاليات، وتدفق عملاء مضمون.',
          sections: [
            {
              heading: 'الإعلام والحملات العالمية',
              subtitle: 'ظهور مجدول يعزز علامتك.',
              points: [
                'الاستضافة في البرنامج التلفزيوني مرة واحدة في السنة.',
                'الاستضافة مرتين في الندوات التعريفية بالشركات.',
                'الإعلان عن مقدم الخدمة في كل الحملات التسويقية الخاصة بالنادي على مستوى العالم.',
              ],
              footerText: 'اطلع على أثر الإعلام والفعاليات.',
              footerHash: 'partners-banner',
              footerCta: 'عرض ركائز القوة',
            },
            {
              heading: 'تدفق العملاء',
              subtitle: 'حجم عملاء متوقع دون مصاريف إدارية.',
              points: [
                'توجيه 30 عميلاً على الأقل في السنة لمقدم الخدمة دون أي مصاريف إدارية أو عمولات.',
              ],
              footerText: 'ناقش الأهداف ونطاق الاشتراك مع الفريق.',
              footerHash: 'contact',
              footerCta: 'تواصل معنا',
            },
            {
              heading: 'الحضور في المنصة',
              subtitle: 'تميّز في قائمة الموصى بهم عالمياً.',
              points: [
                'الإدراج في قائمة الموصى بهم على المنصة والتطبيق عالمياً كمقدم خدمة.',
              ],
              footerText: 'ابدأ طلب الانضمام كمقدم خدمة.',
              footerHash: 'registration',
              footerCta: 'الانتقال إلى التسجيل',
            },
          ],
          image:
            'https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1400&q=80',
        },
        {
          title: 'مميزات الانضمام كعميل',
          intro:
            'توفير تكاليف ووقت وجهد — حماية أعمالك مع مستشار يرافقك أينما كنت. ملاحظة: هذه بعض الخدمات المجانية للمشتركين، وسنعلن عن باقات إضافية عند الإطلاق.',
          sections: [
            {
              heading: 'أولاً: خدمات الاستشارات الفورية (On-Demand).',
              subtitle: 'إجابات سريعة ودعم عاجل عند الحاجة.',
              points: [
                'دعم سؤال وجواب عبر الدردشة مع ردود قانونية أو محاسبية خلال ساعات.',
                'مكالمات طوارئ مع مستشار متخصص (صوت/فيديو) بعدد دقائق محدد شهرياً للحالات العاجلة.',
              ],
              footerText: 'استفسر عن العضوية عند إطلاق النادي.',
              footerHash: 'contact',
              footerCta: 'تواصل معنا',
            },
            {
              heading: 'ثانياً: المكتبة والوثائق.',
              subtitle: 'نماذج ومراجعات تدعم الامتثال.',
              points: [
                'نماذج عقود جاهزة (توظيف، توريد، شراكة، إيجار) قابلة للتحميل والتعديل.',
                'نماذج محاسبية عملية لإدارة الرواتب والتدفقات النقدية والميزانية.',
                'مراجعة عقد أو عقدين شهرياً قبل التوقيع للتأكد من السلامة القانونية.',
              ],
              footerText: 'تعرّف على مجالات الخدمات لدينا.',
              footerHash: 'services',
              footerCta: 'عرض الخدمات',
            },
            {
              heading: 'ثالثاً: الامتثال والضرائب.',
              subtitle: 'مواعيد وتقارير وتحديثات مبسطة.',
              points: [
                'تنبيهات بالمواعيد الرسمية مثل الإقرارات الضريبية والتأمينات وتجديد السجلات التجارية.',
                'تقرير ربع سنوي لفحص الموقف الضريبي وإبراز المخاطر المحتملة.',
                'نشرة دورية مبسطة لتحديثات القوانين وتأثيرها على أعمال العميل.',
              ],
              footerText: 'ناقش الالتزامات والمراجعة الضريبية.',
              footerHash: 'contact',
              footerCta: 'تواصل معنا',
            },
            {
              heading: 'رابعاً: خدمات القيمة المضافة (Premium Services).',
              subtitle: 'خصومات وتكامل ودعم نزاعات.',
              points: [
                'خصومات أو باقات خاصة لتأسيس الشركات وتغيير الكيان القانوني.',
                'إمكانية الربط مع أنظمة المحاسبة لتتبع الإيرادات والمصروفات.',
                'استشارات للتحكيم الودي وحل النزاعات قبل الوصول للمحاكم.',
              ],
              footerText: 'المزيد من مستويات الاشتراك تُعلن عند الإطلاق.',
              footerHash: 'contact',
              footerCta: 'تواصل معنا',
            },
          ],
          image:
            'https://images.unsplash.com/photo-1553729459-efe14ef6055d?auto=format&fit=crop&w=1400&q=80',
        },
      ],
    },
    registration: {
      kicker: 'انضم لنا',
      title:
        'نحن نربط الخبرة بالاحتياج... سجّل بياناتك الآن لتكون جزءاً من أكبر تجمع استشاري رقمي',
      tabPartner: 'طلب وكيل',
      tabProvider: 'مقدّم خدمة',
      formNext: 'التالي',
      formPrevious: 'السابق',
      formStep: 'الخطوة {{n}} من {{t}}',
      submit: 'إرسال الطلب',
      submitting: 'جارٍ الإرسال...',
      success: 'تم إرسال الطلب بنجاح.',
      error: 'تعذر إرسال الطلب حالياً. يرجى المحاولة مرة أخرى.',
      missingEndpoint: 'لم يتم إعداد خدمة الإرسال بعد. يرجى ضبط REACT_APP_STATICFORMS_ACCESS_KEY.',
    },
    contactBanner: {
      title: 'اتصل بنا',
      subtitle: 'تواصل مع فريقنا مباشرة عبر البريد الإلكتروني أو الهاتف.',
      emailLabel: 'البريد الإلكتروني',
      emailValue: 'contact@holol.club',
      phoneLabel: 'رقم الهاتف',
      phoneValue: '+447832180705',
    },
    aboutPage: {
      title: 'من نحن؟',
      introTagline: 'أول فرنشايز رقمي للاستشارات والأعمال في العالم',
      intro:
        'نادي حلول هو منصة رقمية رائدة صُممت لتكون الشريك الاستراتيجي الأول لرواد الأعمال والشركات. نحن لا نقدم مجرد استشارات، بل نبني منظومة متكاملة تدمج بين الخبرة البشرية العميقة وأحدث الأدوات التقنية، لنوفر لعملائنا بيئة عمل آمنة ومستقرة تدفعهم نحو النمو والتميز في الأسواق المحلية والدولية.',
      visionMessage: {
        title: 'الرؤية والرسالة',
        paragraphs: [
          'أن نصبح الوجهة الرقمية الأكثر موثوقية وابتكاراً في عالم الاستشارات والأعمال، محققين الريادة في الربط بين الخبرة والاحتياج عبر الأسواق العربية والأوروبية.',
          'تمكين أصحاب المشاريع من خلال تقديم حلول استشارية، قانونية، وإدارية ذكية، تتسم بالدقة والسرعة وسهولة الوصول. نحن نهدف إلى إزالة كافة العوائق الإدارية من طريق عملائنا، لنمنحهم التركيز الكامل على الإبداع والتوسع في أعمالهم.',
          'نادي حلول هو منظومة دولية رائدة تهدف إلى إعادة ابتكار قطاع الاستشارات من خلال دمج الخبرة البشرية النخبوية بالذكاء الاصطناعي والقوة الإعلامية. نسعى للتوسع في 50 دولة، بدعم من مراكزنا الرئيسية في (مصر، السعودية، الإمارات) لتوفير حلول عابرة للحدود لقطاع الأعمال.',
        ],
      },
      pillars: {
        title: 'الركائز الجوهرية (لماذا نحن مختلفون؟)',
        intro: 'يعتمد "نادي حلول" على مثلث ذهبي يمنحنا التفوق على أي مكتب استشارات تقليدي:',
        items: [
          {
            title: 'القوة الإعلامية',
            body:
              'شراكات استراتيجية مع قنوات فضائية لتقديم 3 برامج تلفزيونية متخصصة، تضع خبراء النادي كقادة رأي أمام ملايين المشاهدين.',
          },
          {
            title: 'النفوذ الميداني',
            body:
              'شراكات مع كبرى أندية النخبة والنوادي الرياضية لإقامة ندوات استثمارية مباشرة تهدف إلى بناء مجتمع أعمال حقيقي.',
          },
          {
            title: 'التحالفات المصرفية',
            body:
              'تعاون وثيق مع المؤسسات البنكية لتسهيل الحلول التمويلية ودعم المشاريع الناشئة والمتوسطة لأعضاء النادي.',
          },
        ],
      },
      values: {
        title: 'قيمنا المؤسسية',
        items: [
          {
            title: 'الموثوقية',
            body: 'نعتز بأمانة المعلومة ودقة الاستشارة كمعيار أساسي لعملنا.',
          },
          {
            title: 'الابتكار',
            body: 'نسخر التكنولوجيا لابتكار أدوات رقمية تجعل حياة رائد الأعمال أسهل وأكثر كفاءة.',
          },
          {
            title: 'الشراكة',
            body: 'نتعامل مع كل عميل كشريك نجاح؛ فنموه هو المقياس الحقيقي لنجاحنا.',
          },
          {
            title: 'الشفافية',
            body: 'نلتزم بالوضوح التام في كافة إجراءاتنا وحلولنا لبناء جسور ثقة مستدامة.',
          },
        ],
      },
      specializations: {
        title: 'التخصصات الاستشارية (الركائز الست)',
        intro: 'نقدم خدماتنا من خلال نخبة من "مقدمي الخدمة المعتمدين" في المجالات التالية:',
        items: [
          {
            title: 'القانون',
            body: 'تأسيس الشركات والنزاعات التجارية الدولية.',
          },
          {
            title: 'المحاسبة',
            body: 'التدقيق المالي والضرائب.',
          },
          {
            title: 'التمويل',
            body: 'الوساطة البنكية وجذب المستثمرين.',
          },
          {
            title: 'التسويق',
            body: 'الدعاية الاستراتيجية والنمو الرقمي.',
          },
          {
            title: 'دراسات الجدوى',
            body: 'تحليل السوق وتخطيط الأعمال.',
          },
          {
            title: 'الهجرة',
            body: 'خدمات الإقامة والجنسية للمستثمرين.',
          },
        ],
      },
      technology: {
        title: 'التكنولوجيا: الشراكة مع الذكاء الاصطناعي (Holol AI Core)',
        intro: 'نستخدم أحدث تقنيات الذكاء الاصطناعي كـ "مدير عمليات رقمي" يقوم بـ:',
        items: [
          {
            title: 'التوجيه الذكي (Matching)',
            body: 'ربط العميل بالخبير الأنسب آلياً وبدقة متناهية.',
          },
          {
            title: 'تحليل البيانات',
            body: 'تقديم تقارير استباقية للمستشارين تضمن جودة الاستشارة وسرعة التنفيذ.',
          },
          {
            title: 'الانتشار العالمي',
            body: 'إدارة العمليات في مختلف الدول بلغات متعددة وبكفاءة موحدة.',
          },
        ],
      },
      partnership: {
        title: 'نموذج الشراكة (مقدم الخدمة المعتمد)',
        intro: 'نحن لا نبحث عن مجرد موردين، بل عن شركاء استراتيجيين يستفيدون من:',
        items: [
          {
            title: 'منصة نفوذ',
            body: 'ظهور إعلامي وميداني يعزز قيمة "العلامة التجارية" للشريك.',
          },
          {
            title: 'تدفق العملاء',
            body: 'نظام إحالة ذكي (Leads) يضمن الوصول لعملاء جادين من فئة النخبة.',
          },
          {
            title: 'توسع دولي',
            body: 'فرصة للتواجد في أسواق جديدة تحت مظلة النادي العالمية.',
          },
        ],
      },
      objectives: {
        title: 'أهدافنا الاستراتيجية',
        items: [
          {
            title: 'الحماية الاستباقية',
            body: 'توفير درع قانوني وإداري يحمي الشركات من المخاطر قبل وقوعها.',
          },
          {
            title: 'التحول الرقمي للاستشارات',
            body: 'تحويل الاستشارة التقليدية إلى تجربة رقمية فورية وتفاعلية.',
          },
          {
            title: 'دعم التوسع العابر للحدود',
            body: 'تسهيل دخول الشركات للأسواق الجديدة (العربية والأوروبية) من خلال فهم عميق للتشريعات المحلية.',
          },
          {
            title: 'الاستجابة الفورية',
            body: 'الالتزام بتقديم الدعم اللازم في أوقات الطوارئ الإدارية والقانونية لضمان استمرارية الأعمال.',
          },
          {
            title: 'بناء مجتمع الخبراء',
            body: 'خلق شبكة تضم نخبة مقدمي الخدمات والمستشارين لتقديم قيمة مضافة لا تضاهى.',
          },
        ],
      },
      closing: {
        title: 'الخاتمة',
        body:
          'نادي حلول هو المكان الذي تلتقي فيه التكنولوجيا بالخبرة لتصنع مستقبلاً جديداً للاستثمار. نحن هنا لنحول التحديات إلى فرص، والأفكار إلى واقع ملموس عابر للحدود.',
      },
    },
    footer: {
      tagline: 'دفتر التميز السيادي في الأعمال. نصنع الإرث عبر الحدود.',
      navTitle: 'التنقل',
      legalTitle: 'قانوني وخصوصية',
      hubsTitle: 'المراكز الإقليمية',
      privacy: 'سياسة الخصوصية',
      terms: 'شروط الخدمة',
      login: 'دخول الأعضاء',
      offices: 'المكاتب العالمية',
      copyright: 'نادي حلول للاستشارات من حلول العالمية - د/ أدهم الشرقاوي. جميع الحقوق محفوظة.',
      ariaWebsite: 'الموقع',
      ariaShare: 'مشاركة',
      ariaEmail: 'البريد',
      ariaLinkedIn: 'لينكدإن',
      ariaYouTube: 'يوتيوب',
      ariaTwitter: 'تويتر',
      ariaFacebook: 'فيسبوك',
    },
    hubs: ['دبي / مركز دبي المالي العالمي', 'الرياض / كافد', 'لندن / مايفير', 'نيويورك / وول ستريت'],
    founderPage: {
      kicker: 'صاحب المشروع',
      name: 'د. أدهم الشرقاوي',
      role: 'خبير استراتيجي في تطوير المشروعات الإعلامية والاستثمارية',
      experienceChip: 'خبرة قيادية تمتد لأكثر من 25 عاماً',
      profile: {
        title: 'الملخص المهني',
        body:
          'رائد أعمال ومطور أفكار استراتيجية يتمتع بخبرة تمتد لأكثر من 25 عاماً في بناء وإدارة الكيانات الاقتصادية الكبرى. متخصص في صياغة "التحالفات الاستراتيجية" التي تدمج بين القوة الإعلامية والحلول الرقمية والواقع الاستثماري. يُعرف بقدرته الفريدة على تحويل الرؤى المعقدة إلى مشاريع قومية وإقليمية ناجحة، مع تركيز خاص على قطاعات الاستشارات والعقارات.',
        highlights: [
          { icon: 'workspace_premium', label: 'خبرة تمتد لأكثر من 25 عاماً' },
          { icon: 'hub', label: 'تحالفات الإعلام × البيزنس' },
          { icon: 'trending_up', label: 'الاستشارات والعقارات' },
          { icon: 'public', label: 'حضور إقليمي ودولي' },
        ],
      },
      milestones: {
        title: 'المحطات الاستراتيجية الأبرز',
        subtitle: 'مسيرة تدمج القوة الإعلامية بالواقع الاستثماري',
        items: [
          {
            period: 'مجموعة قنوات CBC',
            role: 'مدير إدارة تطوير المشروعات الإعلامية',
            icon: 'live_tv',
            points: [
              'قاد عمليات الابتكار وتطوير المحتوى الاستثماري في واحدة من أكبر المجموعات الإعلامية في الشرق الأوسط.',
              'نجح في خلق لغة مشتركة بين الإعلام التقليدي واحتياجات مجتمع الأعمال، مما عزّز من القوة التأثيرية للمجموعة.',
            ],
          },
          {
            period: 'مشروع "مزادات"',
            role: 'مؤسس وصاحب الفكرة',
            icon: 'gavel',
            points: [
              'صاحب الرؤية والمدير المباشر لأول مشروع يدمج بين الإعلام المرئي والتبادل العقاري/الاستثماري بالتعاون مع CBC.',
              'حقق المشروع طفرة في مفهوم "المزادات التلفزيونية" وحوّلها إلى أداة اقتصادية فعّالة وثّقت حلقاته نجاحاتها.',
            ],
          },
          {
            period: 'مجموعة بنان (Banan Group)',
            role: 'القيادة المؤسسية — المدير العام',
            icon: 'apartment',
            points: [
              'بنان للحلول المتكاملة: تطوير الأنظمة الإدارية والاستراتيجية.',
              'بنان للتسويق العقاري: إدارة المحافظ العقارية الكبرى.',
              'بنان للخدمات الاستراتيجية والتسويقية: بناء العلامات التجارية وتطوير الأسواق.',
            ],
          },
        ],
      },
      mediaSpotlight: {
        kicker: 'الإعلام والحضور',
        title: 'برنامج مزادات',
        subtitle: 'برنامج مزادات | دكتور أدهم الشرقاوي يتحدث عن تفعيل المشروع مع اللواء طارق مهدي محافظ الإسكندرية.',
        linkHeading: 'التواصل مع دكتور/ ادهم الشرقاوي',
        links: [
          { label: 'www.hololrealestate.club', href: 'https://www.hololrealestate.club' },
          { label: 'adhamelsharkawy.com', href: 'https://www.adhamelsharkawy.com/' },
          { label: 'Linkedin | dr-adhamelsharkawy', href: 'https://www.linkedin.com/in/dr-adhamelsharkawy/' },
          { label: 'Youtube | adhamelsharkaawy', href: 'https://www.youtube.com/@adhamelsharkaawy/' },
          { label: 'Facebook | dr.adhamelsharkaawy', href: 'https://www.facebook.com/dr.adhamelsharkaawy/' },
        ],
        youtubeId: 'eklsLyv3sUc',
      },
      vision: {
        title: 'الرؤية الحالية',
        subtitle:
          'يضع د. أدهم خبراته التراكمية الآن في تأسيس "مجموعة حلول العالمية" (Holol Holding)، والتي تهدف لإطلاق:',
        items: [
          {
            title: 'نادي حلول للاستشارات',
            desc: 'أول فرنشايز استشاري رقمي مدعوم بالذكاء الاصطناعي والإعلام.',
            icon: 'hub',
          },
          {
            title: 'نادي حلول العقاري',
            desc: 'المنظومة الأضخم عالمياً لتبادل وإدارة الخدمات العقارية (50 خدمة متكاملة).',
            icon: 'real_estate_agent',
          },
          {
            title: 'حلول الإعلامية',
            desc: 'الذراع الإعلامي والإنتاجي الذي سيقود المحتوى الاستثماري في 50 دولة.',
            icon: 'campaign',
          },
        ],
      },
      philosophy: {
        title: 'فلسفة العمل',
        quote:
          '"الإعلام ليس مجرد وسيلة للنشر، بل هو المحرك الأساسي لإدارة الأفكار العالمية وصناعة الثقة في الأسواق."',
      },
      cta: {
        primary: 'انضم إلى النادي',
        secondary: 'العودة إلى الرئيسية',
      },
    },
  },
};
